const qe = (o, n) => new Response(o ?? "Not Found", {
  ...n,
  status: 404,
  statusText: "Not Found"
}), Be = (o, n) => new Response(o ?? "Forbidden", {
  ...n,
  status: 403,
  statusText: "Forbidden"
}), xe = (o) => {
  const n = o.match(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);
  return (n == null ? void 0 : n[0]) === o;
}, Ue = (o) => {
  const p = [
    "x-vercel-forwarded-for",
    "x-forwarded-for",
    "x-real-ip"
  ].find((r) => xe(o.headers.get(r) ?? ""));
  if (p)
    return o.headers.get(p);
}, ke = (o, n) => new Response(o ?? "To Many Requests", {
  ...n,
  status: 429,
  statusText: "To Many Requests"
}), _e = (o, n) => new Response(o ?? "OK", {
  ...n,
  status: 200,
  statusText: "OK"
}), Ve = (o, n) => new Response(o ?? "Unauthorized", {
  ...n,
  status: 401,
  statusText: "Unauthorized"
}), We = (o, n) => new Response(o ?? "Bad Request", {
  ...n,
  status: 400,
  statusText: "Bad Request"
}), $e = (o, n) => new Response(o ?? void 0, {
  ...n,
  status: 304,
  statusText: "Not Modified"
}), He = (o, n) => new Response(o ?? "Internal Server Error", {
  ...n,
  status: 500,
  statusText: "Internal Server Error"
}), Ke = (o, n) => new Response(o ?? "Unsupported Media Type", {
  ...n,
  status: 415,
  statusText: "Unsupported Media Type"
}), ze = (o, n) => new Response(o, {
  status: 200,
  statusText: "OK",
  ...n,
  headers: {
    ...n == null ? void 0 : n.headers,
    "Content-Type": "application/xml"
  }
}), Ye = (o, n) => new Response(o, {
  status: 200,
  statusText: "OK",
  ...n,
  headers: {
    ...n == null ? void 0 : n.headers,
    "Content-Type": "application/pdf"
  }
}), Ze = (o, n) => new Response(o, {
  status: 200,
  statusText: "OK",
  ...n,
  headers: {
    ...n == null ? void 0 : n.headers,
    "Content-Type": "text/html"
  }
}), Je = (o, n) => new Response(o ?? "Method Not Allowed", {
  ...n,
  status: 405,
  statusText: "Method Not Allowed"
}), Qe = (o) => {
  const n = new URL(o.url);
  return `${n.protocol}//${n.host}`;
}, Ge = (o) => {
  var p;
  const n = (p = o.headers) == null ? void 0 : p.get("x-vercel-ip-country");
  if (n)
    return n;
};
var v = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Te(o) {
  if (o.__esModule)
    return o;
  var n = o.default;
  if (typeof n == "function") {
    var p = function r() {
      return this instanceof r ? Reflect.construct(n, arguments, this.constructor) : n.apply(this, arguments);
    };
    p.prototype = n.prototype;
  } else
    p = {};
  return Object.defineProperty(p, "__esModule", { value: !0 }), Object.keys(o).forEach(function(r) {
    var f = Object.getOwnPropertyDescriptor(o, r);
    Object.defineProperty(p, r, f.get ? f : {
      enumerable: !0,
      get: function() {
        return o[r];
      }
    });
  }), p;
}
var Oe = { exports: {} };
function Me(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _ = { exports: {} };
const Ne = {}, Le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ne
}, Symbol.toStringTag, { value: "Module" })), ve = /* @__PURE__ */ Te(Le);
var Rt;
function fe() {
  return Rt || (Rt = 1, function(o, n) {
    (function(p, r) {
      o.exports = r();
    })(v, function() {
      var p = p || function(r, f) {
        var t;
        if (typeof window < "u" && window.crypto && (t = window.crypto), typeof self < "u" && self.crypto && (t = self.crypto), typeof globalThis < "u" && globalThis.crypto && (t = globalThis.crypto), !t && typeof window < "u" && window.msCrypto && (t = window.msCrypto), !t && typeof v < "u" && v.crypto && (t = v.crypto), !t && typeof Me == "function")
          try {
            t = ve;
          } catch {
          }
        var e = function() {
          if (t) {
            if (typeof t.getRandomValues == "function")
              try {
                return t.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof t.randomBytes == "function")
              try {
                return t.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || /* @__PURE__ */ function() {
          function w() {
          }
          return function(T) {
            var i;
            return w.prototype = T, i = new w(), w.prototype = null, i;
          };
        }(), a = {}, y = a.lib = {}, u = y.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(w) {
              var T = s(this);
              return w && T.mixIn(w), (!T.hasOwnProperty("init") || this.init === T.init) && (T.init = function() {
                T.$super.init.apply(this, arguments);
              }), T.init.prototype = T, T.$super = this, T;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var w = this.extend();
              return w.init.apply(w, arguments), w;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(w) {
              for (var T in w)
                w.hasOwnProperty(T) && (this[T] = w[T]);
              w.hasOwnProperty("toString") && (this.toString = w.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), m = y.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(w, T) {
            w = this.words = w || [], T != f ? this.sigBytes = T : this.sigBytes = w.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(w) {
            return (w || x).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(w) {
            var T = this.words, i = w.words, l = this.sigBytes, d = w.sigBytes;
            if (this.clamp(), l % 4)
              for (var D = 0; D < d; D++) {
                var h = i[D >>> 2] >>> 24 - D % 4 * 8 & 255;
                T[l + D >>> 2] |= h << 24 - (l + D) % 4 * 8;
              }
            else
              for (var c = 0; c < d; c += 4)
                T[l + c >>> 2] = i[c >>> 2];
            return this.sigBytes += d, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var w = this.words, T = this.sigBytes;
            w[T >>> 2] &= 4294967295 << 32 - T % 4 * 8, w.length = r.ceil(T / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var w = u.clone.call(this);
            return w.words = this.words.slice(0), w;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(w) {
            for (var T = [], i = 0; i < w; i += 4)
              T.push(e());
            return new m.init(T, w);
          }
        }), g = a.enc = {}, x = g.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(w) {
            for (var T = w.words, i = w.sigBytes, l = [], d = 0; d < i; d++) {
              var D = T[d >>> 2] >>> 24 - d % 4 * 8 & 255;
              l.push((D >>> 4).toString(16)), l.push((D & 15).toString(16));
            }
            return l.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(w) {
            for (var T = w.length, i = [], l = 0; l < T; l += 2)
              i[l >>> 3] |= parseInt(w.substr(l, 2), 16) << 24 - l % 8 * 4;
            return new m.init(i, T / 2);
          }
        }, M = g.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(w) {
            for (var T = w.words, i = w.sigBytes, l = [], d = 0; d < i; d++) {
              var D = T[d >>> 2] >>> 24 - d % 4 * 8 & 255;
              l.push(String.fromCharCode(D));
            }
            return l.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(w) {
            for (var T = w.length, i = [], l = 0; l < T; l++)
              i[l >>> 2] |= (w.charCodeAt(l) & 255) << 24 - l % 4 * 8;
            return new m.init(i, T);
          }
        }, N = g.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(w) {
            try {
              return decodeURIComponent(escape(M.stringify(w)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(w) {
            return M.parse(unescape(encodeURIComponent(w)));
          }
        }, I = y.BufferedBlockAlgorithm = u.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new m.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(w) {
            typeof w == "string" && (w = N.parse(w)), this._data.concat(w), this._nDataBytes += w.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(w) {
            var T, i = this._data, l = i.words, d = i.sigBytes, D = this.blockSize, h = D * 4, c = d / h;
            w ? c = r.ceil(c) : c = r.max((c | 0) - this._minBufferSize, 0);
            var b = c * D, O = r.min(b * 4, d);
            if (b) {
              for (var L = 0; L < b; L += D)
                this._doProcessBlock(l, L);
              T = l.splice(0, b), i.sigBytes -= O;
            }
            return new m.init(T, O);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var w = u.clone.call(this);
            return w._data = this._data.clone(), w;
          },
          _minBufferSize: 0
        });
        y.Hasher = I.extend({
          /**
           * Configuration options.
           */
          cfg: u.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(w) {
            this.cfg = this.cfg.extend(w), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            I.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(w) {
            return this._append(w), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(w) {
            w && this._append(w);
            var T = this._doFinalize();
            return T;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(w) {
            return function(T, i) {
              return new w.init(i).finalize(T);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(w) {
            return function(T, i) {
              return new C.HMAC.init(w, i).finalize(T);
            };
          }
        });
        var C = a.algo = {};
        return a;
      }(Math);
      return p;
    });
  }(_)), _.exports;
}
(function(o, n) {
  (function(p, r) {
    o.exports = r(fe());
  })(v, function(p) {
    return p.enc.Hex;
  });
})(Oe);
var Ie = { exports: {} };
(function(o, n) {
  (function(p, r) {
    o.exports = r(fe());
  })(v, function(p) {
    return function() {
      var r = p, f = r.lib, t = f.WordArray, e = f.Hasher, s = r.algo, a = [], y = s.SHA1 = e.extend({
        _doReset: function() {
          this._hash = new t.init([
            1732584193,
            4023233417,
            2562383102,
            271733878,
            3285377520
          ]);
        },
        _doProcessBlock: function(u, m) {
          for (var g = this._hash.words, x = g[0], M = g[1], N = g[2], I = g[3], C = g[4], w = 0; w < 80; w++) {
            if (w < 16)
              a[w] = u[m + w] | 0;
            else {
              var T = a[w - 3] ^ a[w - 8] ^ a[w - 14] ^ a[w - 16];
              a[w] = T << 1 | T >>> 31;
            }
            var i = (x << 5 | x >>> 27) + C + a[w];
            w < 20 ? i += (M & N | ~M & I) + 1518500249 : w < 40 ? i += (M ^ N ^ I) + 1859775393 : w < 60 ? i += (M & N | M & I | N & I) - 1894007588 : i += (M ^ N ^ I) - 899497514, C = I, I = N, N = M << 30 | M >>> 2, M = x, x = i;
          }
          g[0] = g[0] + x | 0, g[1] = g[1] + M | 0, g[2] = g[2] + N | 0, g[3] = g[3] + I | 0, g[4] = g[4] + C | 0;
        },
        _doFinalize: function() {
          var u = this._data, m = u.words, g = this._nDataBytes * 8, x = u.sigBytes * 8;
          return m[x >>> 5] |= 128 << 24 - x % 32, m[(x + 64 >>> 9 << 4) + 14] = Math.floor(g / 4294967296), m[(x + 64 >>> 9 << 4) + 15] = g, u.sigBytes = m.length * 4, this._process(), this._hash;
        },
        clone: function() {
          var u = e.clone.call(this);
          return u._hash = this._hash.clone(), u;
        }
      });
      r.SHA1 = e._createHelper(y), r.HmacSHA1 = e._createHmacHelper(y);
    }(), p.SHA1;
  });
})(Ie);
typeof atob > "u" && (global.atob = function(o) {
  return Buffer.from(o, "base64").toString("utf-8");
});
class Ee extends Error {
  constructor(n) {
    super(`${n == null ? void 0 : n.status} - ${n == null ? void 0 : n.statusText}`), this._response = n;
  }
  get response() {
    return this._response;
  }
  toResponse() {
    var n, p, r;
    const f = this.response.headers.get("content-type") === "application/json" ? JSON.stringify(this.response.data) : (n = this.response.data) == null ? void 0 : n.toString();
    return new Response(f, {
      status: (p = this.response) == null ? void 0 : p.status,
      statusText: (r = this.response) == null ? void 0 : r.statusText
    });
  }
}
function tr(o, n) {
  return new Promise(async (p, r) => {
    try {
      const f = await o;
      if (f instanceof Ee) {
        if (typeof n == "function") {
          const t = n(f.response.data);
          p(t);
          return;
        }
        p(f.response.data);
      } else {
        if (typeof n == "function") {
          const t = n(f.data);
          p(t);
          return;
        }
        p(f.data);
      }
    } catch (f) {
      r(f);
    }
  });
}
const er = (o) => new Promise((n, p) => {
  const r = [];
  o.on("data", (f) => r.push(f)), o.on("error", p), o.on("end", () => n(Buffer.concat(r)));
}), B = (o) => o == null ? !1 : o != null && typeof o == "string", F = (o) => {
  var n;
  return o == null ? !0 : B(o) ? (((n = o == null ? void 0 : o.trim()) == null ? void 0 : n.length) ?? 0) === 0 : !1;
}, Ce = ({ title: o, description: n, robots: p, keywords: r, canonical: f, alternate: t, og: e }) => {
  const s = [];
  if (F(o) || s.push({
    title: o
  }), F(n) || s.push({
    name: "description",
    content: n
  }), F(p) || s.push({
    name: "robots",
    content: p
  }), F(r) || s.push({
    name: "keywords",
    content: r
  }), f && s.push({
    tagName: "link",
    rel: "canonical",
    href: f
  }), t) {
    t.locales.forEach((y) => {
      const u = new URL(t.baseUrl);
      u.pathname = F(y.pathPrefix ?? "") ? t.path : `/${y.pathPrefix}${t.path}`, s.push({
        tagName: "link",
        rel: "alternate",
        hrefLang: y.lang,
        href: u.toString()
      });
    });
    const a = t.locales.find((y) => y.default === !0);
    if (a) {
      const y = new URL(t.baseUrl);
      y.pathname = F(a.pathPrefix ?? "") ? t.path : `/${a.pathPrefix}${t.path}`, s.push({
        tagName: "link",
        rel: "alternate",
        hrefLang: "x-default",
        href: y.toString()
      });
    }
  }
  return e && Object.keys(e).forEach((a) => {
    const y = e[a];
    F(y) || s.push({
      property: `og:${a}`,
      content: y
    });
  }), s;
}, rr = Ce, ir = ({ url: o }) => ({
  tagName: "link",
  rel: "canonical",
  href: o
}), nr = ({ baseUrl: o, path: n, locales: p, defaultLocale: r }) => p.reduce((f, t) => {
  const e = B(t) ? t : t.pathPrefix, s = "link", a = "alternate", y = F(e) ? `${o}${n}` : `${o}/${e}${n}`;
  return r === (B(t) ? t : t.locale) && f.push({
    tagName: s,
    rel: a,
    href: y,
    hrefLang: "x-default"
  }), f.push({ tagName: s, rel: a, href: y, hrefLang: B(t) ? t : t.locale }), f;
}, []);
var A = {}, At;
function j() {
  return At || (At = 1, (function() {
    var o, n, p, r, f, t, e, s = {}.hasOwnProperty;
    o = function(a, ...y) {
      var u, m, g, x;
      if (f(Object.assign))
        Object.assign.apply(null, arguments);
      else
        for (u = 0, g = y.length; u < g; u++)
          if (x = y[u], x != null)
            for (m in x)
              s.call(x, m) && (a[m] = x[m]);
      return a;
    }, f = function(a) {
      return !!a && Object.prototype.toString.call(a) === "[object Function]";
    }, t = function(a) {
      var y;
      return !!a && ((y = typeof a) == "function" || y === "object");
    }, p = function(a) {
      return f(Array.isArray) ? Array.isArray(a) : Object.prototype.toString.call(a) === "[object Array]";
    }, r = function(a) {
      var y;
      if (p(a))
        return !a.length;
      for (y in a)
        if (s.call(a, y))
          return !1;
      return !0;
    }, e = function(a) {
      var y, u;
      return t(a) && (u = Object.getPrototypeOf(a)) && (y = u.constructor) && typeof y == "function" && y instanceof y && Function.prototype.toString.call(y) === Function.prototype.toString.call(Object);
    }, n = function(a) {
      return f(a.valueOf) ? a.valueOf() : a;
    }, A.assign = o, A.isFunction = f, A.isObject = t, A.isArray = p, A.isEmpty = r, A.isPlainObject = e, A.getValue = n;
  }).call(v)), A;
}
var V = { exports: {} }, jt;
function pe() {
  return jt || (jt = 1, (function() {
    V.exports = class {
      // Tests if the DOM implementation implements a specific feature.
      // `feature` package name of the feature to test. In Level 1, the
      //           legal values are "HTML" and "XML" (case-insensitive).
      // `version` version number of the package name to test. 
      //           In Level 1, this is the string "1.0". If the version is 
      //           not specified, supporting any version of the feature will 
      //           cause the method to return true.
      hasFeature(n, p) {
        return !0;
      }
      // Creates a new document type declaration.
      // `qualifiedName` qualified name of the document type to be created
      // `publicId` public identifier of the external subset
      // `systemId` system identifier of the external subset
      createDocumentType(n, p, r) {
        throw new Error("This DOM method is not implemented.");
      }
      // Creates a new document.
      // `namespaceURI` namespace URI of the document element to create
      // `qualifiedName` the qualified name of the document to be created
      // `doctype` the type of document to be created or null
      createDocument(n, p, r) {
        throw new Error("This DOM method is not implemented.");
      }
      // Creates a new HTML document.
      // `title` document title
      createHTMLDocument(n) {
        throw new Error("This DOM method is not implemented.");
      }
      // Returns a specialized object which implements the specialized APIs 
      // of the specified feature and version.
      // `feature` name of the feature requested.
      // `version` version number of the feature to test
      getFeature(n, p) {
        throw new Error("This DOM method is not implemented.");
      }
    };
  }).call(v)), V.exports;
}
var W = { exports: {} }, $ = { exports: {} }, H = { exports: {} }, Ft;
function Pe() {
  return Ft || (Ft = 1, (function() {
    H.exports = class {
      // Initializes a new instance of `XMLDOMErrorHandler`
      constructor() {
      }
      // Called on the error handler when an error occurs.
      // `error` the error message as a string
      handleError(n) {
        throw new Error(n);
      }
    };
  }).call(v)), H.exports;
}
var K = { exports: {} }, qt;
function Xe() {
  return qt || (qt = 1, (function() {
    K.exports = (function() {
      class o {
        // Initializes a new instance of `XMLDOMStringList`
        // This is just a wrapper around an ordinary
        // JS array.
        // `arr` the array of string values
        constructor(p) {
          this.arr = p || [];
        }
        // Returns the indexth item in the collection.
        // `index` index into the collection
        item(p) {
          return this.arr[p] || null;
        }
        // Test if a string is part of this DOMStringList.
        // `str` the string to look for
        contains(p) {
          return this.arr.indexOf(p) !== -1;
        }
      }
      return Object.defineProperty(o.prototype, "length", {
        get: function() {
          return this.arr.length;
        }
      }), o;
    }).call(this);
  }).call(v)), K.exports;
}
var Bt;
function Se() {
  return Bt || (Bt = 1, (function() {
    var o, n;
    o = Pe(), n = Xe(), $.exports = (function() {
      class p {
        constructor() {
          this.defaultParams = {
            "canonical-form": !1,
            "cdata-sections": !1,
            comments: !1,
            "datatype-normalization": !1,
            "element-content-whitespace": !0,
            entities: !0,
            "error-handler": new o(),
            infoset: !0,
            "validate-if-schema": !1,
            namespaces: !0,
            "namespace-declarations": !0,
            "normalize-characters": !1,
            "schema-location": "",
            "schema-type": "",
            "split-cdata-sections": !0,
            validate: !1,
            "well-formed": !0
          }, this.params = Object.create(this.defaultParams);
        }
        // Gets the value of a parameter.
        // `name` name of the parameter
        getParameter(f) {
          return this.params.hasOwnProperty(f) ? this.params[f] : null;
        }
        // Checks if setting a parameter to a specific value is supported.
        // `name` name of the parameter
        // `value` parameter value
        canSetParameter(f, t) {
          return !0;
        }
        // Sets the value of a parameter.
        // `name` name of the parameter
        // `value` new value or null if the user wishes to unset the parameter
        setParameter(f, t) {
          return t != null ? this.params[f] = t : delete this.params[f];
        }
      }
      return Object.defineProperty(p.prototype, "parameterNames", {
        get: function() {
          return new n(Object.keys(this.defaultParams));
        }
      }), p;
    }).call(this);
  }).call(v)), $.exports;
}
var z = { exports: {} }, Y = { exports: {} }, Z = { exports: {} }, Ut;
function P() {
  return Ut || (Ut = 1, (function() {
    Z.exports = {
      Element: 1,
      Attribute: 2,
      Text: 3,
      CData: 4,
      EntityReference: 5,
      EntityDeclaration: 6,
      ProcessingInstruction: 7,
      Comment: 8,
      Document: 9,
      DocType: 10,
      DocumentFragment: 11,
      NotationDeclaration: 12,
      // Numeric codes up to 200 are reserved to W3C for possible future use.
      // Following are types internal to this library:
      Declaration: 201,
      Raw: 202,
      AttributeDeclaration: 203,
      ElementDeclaration: 204,
      Dummy: 205
    };
  }).call(v)), Z.exports;
}
var J = { exports: {} }, kt;
function me() {
  return kt || (kt = 1, (function() {
    var o;
    o = P(), R(), J.exports = (function() {
      class n {
        // Initializes a new instance of `XMLAttribute`
        // `parent` the parent node
        // `name` attribute target
        // `value` attribute value
        constructor(r, f, t) {
          if (this.parent = r, this.parent && (this.options = this.parent.options, this.stringify = this.parent.stringify), f == null)
            throw new Error("Missing attribute name. " + this.debugInfo(f));
          this.name = this.stringify.name(f), this.value = this.stringify.attValue(t), this.type = o.Attribute, this.isId = !1, this.schemaTypeInfo = null;
        }
        // Creates and returns a deep clone of `this`
        clone() {
          return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(r) {
          return this.options.writer.attribute(this, this.options.writer.filterOptions(r));
        }
        // Returns debug string for this node
        debugInfo(r) {
          return r = r || this.name, r == null ? "parent: <" + this.parent.name + ">" : "attribute: {" + r + "}, parent: <" + this.parent.name + ">";
        }
        isEqualNode(r) {
          return !(r.namespaceURI !== this.namespaceURI || r.prefix !== this.prefix || r.localName !== this.localName || r.value !== this.value);
        }
      }
      return Object.defineProperty(n.prototype, "nodeType", {
        get: function() {
          return this.type;
        }
      }), Object.defineProperty(n.prototype, "ownerElement", {
        get: function() {
          return this.parent;
        }
      }), Object.defineProperty(n.prototype, "textContent", {
        get: function() {
          return this.value;
        },
        set: function(p) {
          return this.value = p || "";
        }
      }), Object.defineProperty(n.prototype, "namespaceURI", {
        get: function() {
          return "";
        }
      }), Object.defineProperty(n.prototype, "prefix", {
        get: function() {
          return "";
        }
      }), Object.defineProperty(n.prototype, "localName", {
        get: function() {
          return this.name;
        }
      }), Object.defineProperty(n.prototype, "specified", {
        get: function() {
          return !0;
        }
      }), n;
    }).call(this);
  }).call(v)), J.exports;
}
var Q = { exports: {} }, _t;
function bt() {
  return _t || (_t = 1, (function() {
    Q.exports = (function() {
      class o {
        // Initializes a new instance of `XMLNamedNodeMap`
        // This is just a wrapper around an ordinary
        // JS object.
        // `nodes` the object containing nodes.
        constructor(p) {
          this.nodes = p;
        }
        // Creates and returns a deep clone of `this`
        clone() {
          return this.nodes = null;
        }
        // DOM Level 1
        getNamedItem(p) {
          return this.nodes[p];
        }
        setNamedItem(p) {
          var r;
          return r = this.nodes[p.nodeName], this.nodes[p.nodeName] = p, r || null;
        }
        removeNamedItem(p) {
          var r;
          return r = this.nodes[p], delete this.nodes[p], r || null;
        }
        item(p) {
          return this.nodes[Object.keys(this.nodes)[p]] || null;
        }
        // DOM level 2 functions to be implemented later
        getNamedItemNS(p, r) {
          throw new Error("This DOM method is not implemented.");
        }
        setNamedItemNS(p) {
          throw new Error("This DOM method is not implemented.");
        }
        removeNamedItemNS(p, r) {
          throw new Error("This DOM method is not implemented.");
        }
      }
      return Object.defineProperty(o.prototype, "length", {
        get: function() {
          return Object.keys(this.nodes).length || 0;
        }
      }), o;
    }).call(this);
  }).call(v)), Q.exports;
}
var Vt;
function xt() {
  return Vt || (Vt = 1, (function() {
    var o, n, p, r, f, t, e, s = {}.hasOwnProperty;
    ({ isObject: e, isFunction: t, getValue: f } = j()), r = R(), o = P(), n = me(), p = bt(), Y.exports = (function() {
      class a extends r {
        // Initializes a new instance of `XMLElement`
        // `parent` the parent node
        // `name` element name
        // `attributes` an object containing name/value pairs of attributes
        constructor(u, m, g) {
          var x, M, N, I;
          if (super(u), m == null)
            throw new Error("Missing element name. " + this.debugInfo());
          if (this.name = this.stringify.name(m), this.type = o.Element, this.attribs = {}, this.schemaTypeInfo = null, g != null && this.attribute(g), u.type === o.Document && (this.isRoot = !0, this.documentObject = u, u.rootObject = this, u.children)) {
            for (I = u.children, M = 0, N = I.length; M < N; M++)
              if (x = I[M], x.type === o.DocType) {
                x.name = this.name;
                break;
              }
          }
        }
        // Creates and returns a deep clone of `this`
        clone() {
          var u, m, g, x;
          g = Object.create(this), g.isRoot && (g.documentObject = null), g.attribs = {}, x = this.attribs;
          for (m in x)
            s.call(x, m) && (u = x[m], g.attribs[m] = u.clone());
          return g.children = [], this.children.forEach(function(M) {
            var N;
            return N = M.clone(), N.parent = g, g.children.push(N);
          }), g;
        }
        // Adds or modifies an attribute
        // `name` attribute name
        // `value` attribute value
        attribute(u, m) {
          var g, x;
          if (u != null && (u = f(u)), e(u))
            for (g in u)
              s.call(u, g) && (x = u[g], this.attribute(g, x));
          else
            t(m) && (m = m.apply()), this.options.keepNullAttributes && m == null ? this.attribs[u] = new n(this, u, "") : m != null && (this.attribs[u] = new n(this, u, m));
          return this;
        }
        // Removes an attribute
        // `name` attribute name
        removeAttribute(u) {
          var m, g, x;
          if (u == null)
            throw new Error("Missing attribute name. " + this.debugInfo());
          if (u = f(u), Array.isArray(u))
            for (g = 0, x = u.length; g < x; g++)
              m = u[g], delete this.attribs[m];
          else
            delete this.attribs[u];
          return this;
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        // `options.allowEmpty` do not self close empty element tags
        toString(u) {
          return this.options.writer.element(this, this.options.writer.filterOptions(u));
        }
        // Aliases
        att(u, m) {
          return this.attribute(u, m);
        }
        a(u, m) {
          return this.attribute(u, m);
        }
        // DOM Level 1
        getAttribute(u) {
          return this.attribs.hasOwnProperty(u) ? this.attribs[u].value : null;
        }
        setAttribute(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getAttributeNode(u) {
          return this.attribs.hasOwnProperty(u) ? this.attribs[u] : null;
        }
        setAttributeNode(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        removeAttributeNode(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByTagName(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM Level 2
        getAttributeNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        setAttributeNS(u, m, g) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        removeAttributeNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getAttributeNodeNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        setAttributeNodeNS(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByTagNameNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        hasAttribute(u) {
          return this.attribs.hasOwnProperty(u);
        }
        hasAttributeNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM Level 3
        setIdAttribute(u, m) {
          return this.attribs.hasOwnProperty(u) ? this.attribs[u].isId : m;
        }
        setIdAttributeNS(u, m, g) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        setIdAttributeNode(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM Level 4
        getElementsByTagName(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByTagNameNS(u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByClassName(u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        isEqualNode(u) {
          var m, g, x;
          if (!super.isEqualNode(u) || u.namespaceURI !== this.namespaceURI || u.prefix !== this.prefix || u.localName !== this.localName || u.attribs.length !== this.attribs.length)
            return !1;
          for (m = g = 0, x = this.attribs.length - 1; 0 <= x ? g <= x : g >= x; m = 0 <= x ? ++g : --g)
            if (!this.attribs[m].isEqualNode(u.attribs[m]))
              return !1;
          return !0;
        }
      }
      return Object.defineProperty(a.prototype, "tagName", {
        get: function() {
          return this.name;
        }
      }), Object.defineProperty(a.prototype, "namespaceURI", {
        get: function() {
          return "";
        }
      }), Object.defineProperty(a.prototype, "prefix", {
        get: function() {
          return "";
        }
      }), Object.defineProperty(a.prototype, "localName", {
        get: function() {
          return this.name;
        }
      }), Object.defineProperty(a.prototype, "id", {
        get: function() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), Object.defineProperty(a.prototype, "className", {
        get: function() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), Object.defineProperty(a.prototype, "classList", {
        get: function() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), Object.defineProperty(a.prototype, "attributes", {
        get: function() {
          return (!this.attributeMap || !this.attributeMap.nodes) && (this.attributeMap = new p(this.attribs)), this.attributeMap;
        }
      }), a;
    }).call(this);
  }).call(v)), Y.exports;
}
var G = { exports: {} }, tt = { exports: {} }, Wt;
function U() {
  return Wt || (Wt = 1, (function() {
    var o;
    o = R(), tt.exports = (function() {
      class n extends o {
        // Initializes a new instance of `XMLCharacterData`
        constructor(r) {
          super(r), this.value = "";
        }
        // Creates and returns a deep clone of `this`
        clone() {
          return Object.create(this);
        }
        // DOM level 1 functions to be implemented later
        substringData(r, f) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        appendData(r) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        insertData(r, f) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        deleteData(r, f) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        replaceData(r, f, t) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        isEqualNode(r) {
          return !(!super.isEqualNode(r) || r.data !== this.data);
        }
      }
      return Object.defineProperty(n.prototype, "data", {
        get: function() {
          return this.value;
        },
        set: function(p) {
          return this.value = p || "";
        }
      }), Object.defineProperty(n.prototype, "length", {
        get: function() {
          return this.value.length;
        }
      }), Object.defineProperty(n.prototype, "textContent", {
        get: function() {
          return this.value;
        },
        set: function(p) {
          return this.value = p || "";
        }
      }), n;
    }).call(this);
  }).call(v)), tt.exports;
}
var $t;
function Tt() {
  return $t || ($t = 1, (function() {
    var o, n;
    o = P(), n = U(), G.exports = class extends n {
      // Initializes a new instance of `XMLCData`
      // `text` CDATA text
      constructor(r, f) {
        if (super(r), f == null)
          throw new Error("Missing CDATA text. " + this.debugInfo());
        this.name = "#cdata-section", this.type = o.CData, this.value = this.stringify.cdata(f);
      }
      // Creates and returns a deep clone of `this`
      clone() {
        return Object.create(this);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.cdata(this, this.options.writer.filterOptions(r));
      }
    };
  }).call(v)), G.exports;
}
var et = { exports: {} }, Ht;
function Ot() {
  return Ht || (Ht = 1, (function() {
    var o, n;
    o = P(), n = U(), et.exports = class extends n {
      // Initializes a new instance of `XMLComment`
      // `text` comment text
      constructor(r, f) {
        if (super(r), f == null)
          throw new Error("Missing comment text. " + this.debugInfo());
        this.name = "#comment", this.type = o.Comment, this.value = this.stringify.comment(f);
      }
      // Creates and returns a deep clone of `this`
      clone() {
        return Object.create(this);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.comment(this, this.options.writer.filterOptions(r));
      }
    };
  }).call(v)), et.exports;
}
var rt = { exports: {} }, Kt;
function Mt() {
  return Kt || (Kt = 1, (function() {
    var o, n, p;
    ({ isObject: p } = j()), n = R(), o = P(), rt.exports = class extends n {
      // Initializes a new instance of `XMLDeclaration`
      // `parent` the document object
      // `version` A version number string, e.g. 1.0
      // `encoding` Encoding declaration, e.g. UTF-8
      // `standalone` standalone document declaration: true or false
      constructor(f, t, e, s) {
        super(f), p(t) && ({ version: t, encoding: e, standalone: s } = t), t || (t = "1.0"), this.type = o.Declaration, this.version = this.stringify.xmlVersion(t), e != null && (this.encoding = this.stringify.xmlEncoding(e)), s != null && (this.standalone = this.stringify.xmlStandalone(s));
      }
      // Converts to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(f) {
        return this.options.writer.declaration(this, this.options.writer.filterOptions(f));
      }
    };
  }).call(v)), rt.exports;
}
var it = { exports: {} }, nt = { exports: {} }, zt;
function Nt() {
  return zt || (zt = 1, (function() {
    var o, n;
    n = R(), o = P(), nt.exports = class extends n {
      // Initializes a new instance of `XMLDTDAttList`
      // `parent` the parent `XMLDocType` element
      // `elementName` the name of the element containing this attribute
      // `attributeName` attribute name
      // `attributeType` type of the attribute
      // `defaultValueType` default value type (either #REQUIRED, #IMPLIED,
      //                    #FIXED or #DEFAULT)
      // `defaultValue` default value of the attribute
      //                (only used for #FIXED or #DEFAULT)
      constructor(r, f, t, e, s, a) {
        if (super(r), f == null)
          throw new Error("Missing DTD element name. " + this.debugInfo());
        if (t == null)
          throw new Error("Missing DTD attribute name. " + this.debugInfo(f));
        if (!e)
          throw new Error("Missing DTD attribute type. " + this.debugInfo(f));
        if (!s)
          throw new Error("Missing DTD attribute default. " + this.debugInfo(f));
        if (s.indexOf("#") !== 0 && (s = "#" + s), !s.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/))
          throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(f));
        if (a && !s.match(/^(#FIXED|#DEFAULT)$/))
          throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(f));
        this.elementName = this.stringify.name(f), this.type = o.AttributeDeclaration, this.attributeName = this.stringify.name(t), this.attributeType = this.stringify.dtdAttType(e), a && (this.defaultValue = this.stringify.dtdAttDefault(a)), this.defaultValueType = s;
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.dtdAttList(this, this.options.writer.filterOptions(r));
      }
    };
  }).call(v)), nt.exports;
}
var st = { exports: {} }, Yt;
function Lt() {
  return Yt || (Yt = 1, (function() {
    var o, n, p;
    ({ isObject: p } = j()), n = R(), o = P(), st.exports = (function() {
      class r extends n {
        // Initializes a new instance of `XMLDTDEntity`
        // `parent` the parent `XMLDocType` element
        // `pe` whether this is a parameter entity or a general entity
        //      defaults to `false` (general entity)
        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        // `value.nData` notation declaration
        constructor(t, e, s, a) {
          if (super(t), s == null)
            throw new Error("Missing DTD entity name. " + this.debugInfo(s));
          if (a == null)
            throw new Error("Missing DTD entity value. " + this.debugInfo(s));
          if (this.pe = !!e, this.name = this.stringify.name(s), this.type = o.EntityDeclaration, !p(a))
            this.value = this.stringify.dtdEntityValue(a), this.internal = !0;
          else {
            if (!a.pubID && !a.sysID)
              throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(s));
            if (a.pubID && !a.sysID)
              throw new Error("System identifier is required for a public external entity. " + this.debugInfo(s));
            if (this.internal = !1, a.pubID != null && (this.pubID = this.stringify.dtdPubID(a.pubID)), a.sysID != null && (this.sysID = this.stringify.dtdSysID(a.sysID)), a.nData != null && (this.nData = this.stringify.dtdNData(a.nData)), this.pe && this.nData)
              throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(s));
          }
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(t) {
          return this.options.writer.dtdEntity(this, this.options.writer.filterOptions(t));
        }
      }
      return Object.defineProperty(r.prototype, "publicId", {
        get: function() {
          return this.pubID;
        }
      }), Object.defineProperty(r.prototype, "systemId", {
        get: function() {
          return this.sysID;
        }
      }), Object.defineProperty(r.prototype, "notationName", {
        get: function() {
          return this.nData || null;
        }
      }), Object.defineProperty(r.prototype, "inputEncoding", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(r.prototype, "xmlEncoding", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(r.prototype, "xmlVersion", {
        get: function() {
          return null;
        }
      }), r;
    }).call(this);
  }).call(v)), st.exports;
}
var ot = { exports: {} }, Zt;
function vt() {
  return Zt || (Zt = 1, (function() {
    var o, n;
    n = R(), o = P(), ot.exports = class extends n {
      // Initializes a new instance of `XMLDTDElement`
      // `parent` the parent `XMLDocType` element
      // `name` element name
      // `value` element content (defaults to #PCDATA)
      constructor(r, f, t) {
        if (super(r), f == null)
          throw new Error("Missing DTD element name. " + this.debugInfo());
        t || (t = "(#PCDATA)"), Array.isArray(t) && (t = "(" + t.join(",") + ")"), this.name = this.stringify.name(f), this.type = o.ElementDeclaration, this.value = this.stringify.dtdElementValue(t);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.dtdElement(this, this.options.writer.filterOptions(r));
      }
    };
  }).call(v)), ot.exports;
}
var at = { exports: {} }, Jt;
function It() {
  return Jt || (Jt = 1, (function() {
    var o, n;
    n = R(), o = P(), at.exports = (function() {
      class p extends n {
        // Initializes a new instance of `XMLDTDNotation`
        // `parent` the parent `XMLDocType` element
        // `name` the name of the notation
        // `value` an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        constructor(f, t, e) {
          if (super(f), t == null)
            throw new Error("Missing DTD notation name. " + this.debugInfo(t));
          if (!e.pubID && !e.sysID)
            throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(t));
          this.name = this.stringify.name(t), this.type = o.NotationDeclaration, e.pubID != null && (this.pubID = this.stringify.dtdPubID(e.pubID)), e.sysID != null && (this.sysID = this.stringify.dtdSysID(e.sysID));
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(f) {
          return this.options.writer.dtdNotation(this, this.options.writer.filterOptions(f));
        }
      }
      return Object.defineProperty(p.prototype, "publicId", {
        get: function() {
          return this.pubID;
        }
      }), Object.defineProperty(p.prototype, "systemId", {
        get: function() {
          return this.sysID;
        }
      }), p;
    }).call(this);
  }).call(v)), at.exports;
}
var Qt;
function Et() {
  return Qt || (Qt = 1, (function() {
    var o, n, p, r, f, t, e, s;
    ({ isObject: s } = j()), e = R(), o = P(), n = Nt(), r = Lt(), p = vt(), f = It(), t = bt(), it.exports = (function() {
      class a extends e {
        // Initializes a new instance of `XMLDocType`
        // `parent` the document object
        // `pubID` public identifier of the external subset
        // `sysID` system identifier of the external subset
        constructor(u, m, g) {
          var x, M, N, I;
          if (super(u), this.type = o.DocType, u.children) {
            for (I = u.children, M = 0, N = I.length; M < N; M++)
              if (x = I[M], x.type === o.Element) {
                this.name = x.name;
                break;
              }
          }
          this.documentObject = u, s(m) && ({ pubID: m, sysID: g } = m), g == null && ([g, m] = [m, g]), m != null && (this.pubID = this.stringify.dtdPubID(m)), g != null && (this.sysID = this.stringify.dtdSysID(g));
        }
        // Creates an element type declaration
        // `name` element name
        // `value` element content (defaults to #PCDATA)
        element(u, m) {
          var g;
          return g = new p(this, u, m), this.children.push(g), this;
        }
        // Creates an attribute declaration
        // `elementName` the name of the element containing this attribute
        // `attributeName` attribute name
        // `attributeType` type of the attribute (defaults to CDATA)
        // `defaultValueType` default value type (either #REQUIRED, #IMPLIED, #FIXED or
        //                    #DEFAULT) (defaults to #IMPLIED)
        // `defaultValue` default value of the attribute
        //                (only used for #FIXED or #DEFAULT)
        attList(u, m, g, x, M) {
          var N;
          return N = new n(this, u, m, g, x, M), this.children.push(N), this;
        }
        // Creates a general entity declaration
        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        // `value.nData` notation declaration
        entity(u, m) {
          var g;
          return g = new r(this, !1, u, m), this.children.push(g), this;
        }
        // Creates a parameter entity declaration
        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        pEntity(u, m) {
          var g;
          return g = new r(this, !0, u, m), this.children.push(g), this;
        }
        // Creates a NOTATION declaration
        // `name` the name of the notation
        // `value` an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        notation(u, m) {
          var g;
          return g = new f(this, u, m), this.children.push(g), this;
        }
        // Converts to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(u) {
          return this.options.writer.docType(this, this.options.writer.filterOptions(u));
        }
        // Aliases
        ele(u, m) {
          return this.element(u, m);
        }
        att(u, m, g, x, M) {
          return this.attList(u, m, g, x, M);
        }
        ent(u, m) {
          return this.entity(u, m);
        }
        pent(u, m) {
          return this.pEntity(u, m);
        }
        not(u, m) {
          return this.notation(u, m);
        }
        up() {
          return this.root() || this.documentObject;
        }
        isEqualNode(u) {
          return !(!super.isEqualNode(u) || u.name !== this.name || u.publicId !== this.publicId || u.systemId !== this.systemId);
        }
      }
      return Object.defineProperty(a.prototype, "entities", {
        get: function() {
          var y, u, m, g, x;
          for (g = {}, x = this.children, u = 0, m = x.length; u < m; u++)
            y = x[u], y.type === o.EntityDeclaration && !y.pe && (g[y.name] = y);
          return new t(g);
        }
      }), Object.defineProperty(a.prototype, "notations", {
        get: function() {
          var y, u, m, g, x;
          for (g = {}, x = this.children, u = 0, m = x.length; u < m; u++)
            y = x[u], y.type === o.NotationDeclaration && (g[y.name] = y);
          return new t(g);
        }
      }), Object.defineProperty(a.prototype, "publicId", {
        get: function() {
          return this.pubID;
        }
      }), Object.defineProperty(a.prototype, "systemId", {
        get: function() {
          return this.sysID;
        }
      }), Object.defineProperty(a.prototype, "internalSubset", {
        get: function() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), a;
    }).call(this);
  }).call(v)), it.exports;
}
var ht = { exports: {} }, Gt;
function Ct() {
  return Gt || (Gt = 1, (function() {
    var o, n;
    o = P(), n = R(), ht.exports = class extends n {
      // Initializes a new instance of `XMLRaw`
      // `text` raw text
      constructor(r, f) {
        if (super(r), f == null)
          throw new Error("Missing raw text. " + this.debugInfo());
        this.type = o.Raw, this.value = this.stringify.raw(f);
      }
      // Creates and returns a deep clone of `this`
      clone() {
        return Object.create(this);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.raw(this, this.options.writer.filterOptions(r));
      }
    };
  }).call(v)), ht.exports;
}
var ut = { exports: {} }, te;
function Pt() {
  return te || (te = 1, (function() {
    var o, n;
    o = P(), n = U(), ut.exports = (function() {
      class p extends n {
        // Initializes a new instance of `XMLText`
        // `text` element text
        constructor(f, t) {
          if (super(f), t == null)
            throw new Error("Missing element text. " + this.debugInfo());
          this.name = "#text", this.type = o.Text, this.value = this.stringify.text(t);
        }
        // Creates and returns a deep clone of `this`
        clone() {
          return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(f) {
          return this.options.writer.text(this, this.options.writer.filterOptions(f));
        }
        // DOM level 1 functions to be implemented later
        splitText(f) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM level 3 functions to be implemented later
        replaceWholeText(f) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }
      return Object.defineProperty(p.prototype, "isElementContentWhitespace", {
        get: function() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), Object.defineProperty(p.prototype, "wholeText", {
        get: function() {
          var r, f, t;
          for (t = "", f = this.previousSibling; f; )
            t = f.data + t, f = f.previousSibling;
          for (t += this.data, r = this.nextSibling; r; )
            t = t + r.data, r = r.nextSibling;
          return t;
        }
      }), p;
    }).call(this);
  }).call(v)), ut.exports;
}
var lt = { exports: {} }, ee;
function Xt() {
  return ee || (ee = 1, (function() {
    var o, n;
    o = P(), n = U(), lt.exports = class extends n {
      // Initializes a new instance of `XMLProcessingInstruction`
      // `parent` the parent node
      // `target` instruction target
      // `value` instruction value
      constructor(r, f, t) {
        if (super(r), f == null)
          throw new Error("Missing instruction target. " + this.debugInfo());
        this.type = o.ProcessingInstruction, this.target = this.stringify.insTarget(f), this.name = this.target, t && (this.value = this.stringify.insValue(t));
      }
      // Creates and returns a deep clone of `this`
      clone() {
        return Object.create(this);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return this.options.writer.processingInstruction(this, this.options.writer.filterOptions(r));
      }
      isEqualNode(r) {
        return !(!super.isEqualNode(r) || r.target !== this.target);
      }
    };
  }).call(v)), lt.exports;
}
var ct = { exports: {} }, re;
function ye() {
  return re || (re = 1, (function() {
    var o, n;
    n = R(), o = P(), ct.exports = class extends n {
      // Initializes a new instance of `XMLDummy`
      // `XMLDummy` is a special node representing a node with 
      // a null value. Dummy nodes are created while recursively
      // building the XML tree. Simply skipping null values doesn't
      // work because that would break the recursive chain.
      constructor(r) {
        super(r), this.type = o.Dummy;
      }
      // Creates and returns a deep clone of `this`
      clone() {
        return Object.create(this);
      }
      // Converts the XML fragment to string
      // `options.pretty` pretty prints the result
      // `options.indent` indentation for pretty print
      // `options.offset` how many indentations to add to every line for pretty print
      // `options.newline` newline sequence for pretty print
      toString(r) {
        return "";
      }
    };
  }).call(v)), ct.exports;
}
var dt = { exports: {} }, ie;
function Re() {
  return ie || (ie = 1, (function() {
    dt.exports = (function() {
      class o {
        // Initializes a new instance of `XMLNodeList`
        // This is just a wrapper around an ordinary
        // JS array.
        // `nodes` the array containing nodes.
        constructor(p) {
          this.nodes = p;
        }
        // Creates and returns a deep clone of `this`
        clone() {
          return this.nodes = null;
        }
        // DOM Level 1
        item(p) {
          return this.nodes[p] || null;
        }
      }
      return Object.defineProperty(o.prototype, "length", {
        get: function() {
          return this.nodes.length || 0;
        }
      }), o;
    }).call(this);
  }).call(v)), dt.exports;
}
var ft = { exports: {} }, ne;
function Ae() {
  return ne || (ne = 1, (function() {
    ft.exports = {
      Disconnected: 1,
      Preceding: 2,
      Following: 4,
      Contains: 8,
      ContainedBy: 16,
      ImplementationSpecific: 32
    };
  }).call(v)), ft.exports;
}
var se;
function R() {
  return se || (se = 1, (function() {
    var o, n, p, r, f, t, e, s, a, y, u, m, g, x, M, N, I = {}.hasOwnProperty, C = [].splice;
    ({ isObject: N, isFunction: M, isEmpty: x, getValue: g } = j()), s = null, p = null, r = null, f = null, t = null, u = null, m = null, y = null, e = null, n = null, a = null, o = null, z.exports = (function() {
      class w {
        // Initializes a new instance of `XMLNode`
        // `parent` the parent node
        constructor(i) {
          this.parent = i, this.parent && (this.options = this.parent.options, this.stringify = this.parent.stringify), this.value = null, this.children = [], this.baseURI = null, s || (s = xt(), p = Tt(), r = Ot(), f = Mt(), t = Et(), u = Ct(), m = Pt(), y = Xt(), e = ye(), n = P(), a = Re(), bt(), o = Ae());
        }
        // Sets the parent node of this node and its children recursively
        // `parent` the parent node
        setParent(i) {
          var l, d, D, h, c;
          for (this.parent = i, i && (this.options = i.options, this.stringify = i.stringify), h = this.children, c = [], d = 0, D = h.length; d < D; d++)
            l = h[d], c.push(l.setParent(this));
          return c;
        }
        // Creates a child element node
        // `name` node name or an object describing the XML tree
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        element(i, l, d) {
          var D, h, c, b, O, L, X, S, E;
          if (L = null, l === null && d == null && ([l, d] = [{}, null]), l == null && (l = {}), l = g(l), N(l) || ([d, l] = [l, d]), i != null && (i = g(i)), Array.isArray(i))
            for (c = 0, X = i.length; c < X; c++)
              h = i[c], L = this.element(h);
          else if (M(i))
            L = this.element(i.apply());
          else if (N(i)) {
            for (O in i)
              if (I.call(i, O))
                if (E = i[O], M(E) && (E = E.apply()), !this.options.ignoreDecorators && this.stringify.convertAttKey && O.indexOf(this.stringify.convertAttKey) === 0)
                  L = this.attribute(O.substr(this.stringify.convertAttKey.length), E);
                else if (!this.options.separateArrayItems && Array.isArray(E) && x(E))
                  L = this.dummy();
                else if (N(E) && x(E))
                  L = this.element(O);
                else if (!this.options.keepNullNodes && E == null)
                  L = this.dummy();
                else if (!this.options.separateArrayItems && Array.isArray(E))
                  for (b = 0, S = E.length; b < S; b++)
                    h = E[b], D = {}, D[O] = h, L = this.element(D);
                else
                  N(E) ? !this.options.ignoreDecorators && this.stringify.convertTextKey && O.indexOf(this.stringify.convertTextKey) === 0 ? L = this.element(E) : (L = this.element(O), L.element(E)) : L = this.element(O, E);
          } else
            !this.options.keepNullNodes && d === null ? L = this.dummy() : !this.options.ignoreDecorators && this.stringify.convertTextKey && i.indexOf(this.stringify.convertTextKey) === 0 ? L = this.text(d) : !this.options.ignoreDecorators && this.stringify.convertCDataKey && i.indexOf(this.stringify.convertCDataKey) === 0 ? L = this.cdata(d) : !this.options.ignoreDecorators && this.stringify.convertCommentKey && i.indexOf(this.stringify.convertCommentKey) === 0 ? L = this.comment(d) : !this.options.ignoreDecorators && this.stringify.convertRawKey && i.indexOf(this.stringify.convertRawKey) === 0 ? L = this.raw(d) : !this.options.ignoreDecorators && this.stringify.convertPIKey && i.indexOf(this.stringify.convertPIKey) === 0 ? L = this.instruction(i.substr(this.stringify.convertPIKey.length), d) : L = this.node(i, l, d);
          if (L == null)
            throw new Error("Could not create any elements with: " + i + ". " + this.debugInfo());
          return L;
        }
        // Creates a child element node before the current node
        // `name` node name or an object describing the XML tree
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        insertBefore(i, l, d) {
          var D, h, c, b, O;
          if (i != null && i.type)
            return c = i, b = l, c.setParent(this), b ? (h = children.indexOf(b), O = children.splice(h), children.push(c), Array.prototype.push.apply(children, O)) : children.push(c), c;
          if (this.isRoot)
            throw new Error("Cannot insert elements at root level. " + this.debugInfo(i));
          return h = this.parent.children.indexOf(this), O = this.parent.children.splice(h), D = this.parent.element(i, l, d), Array.prototype.push.apply(this.parent.children, O), D;
        }
        // Creates a child element node after the current node
        // `name` node name or an object describing the XML tree
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        insertAfter(i, l, d) {
          var D, h, c;
          if (this.isRoot)
            throw new Error("Cannot insert elements at root level. " + this.debugInfo(i));
          return h = this.parent.children.indexOf(this), c = this.parent.children.splice(h + 1), D = this.parent.element(i, l, d), Array.prototype.push.apply(this.parent.children, c), D;
        }
        // Deletes a child element node
        remove() {
          var i;
          if (this.isRoot)
            throw new Error("Cannot remove the root element. " + this.debugInfo());
          return i = this.parent.children.indexOf(this), C.apply(this.parent.children, [i, i - i + 1].concat([])), this.parent;
        }
        // Creates a node
        // `name` name of the node
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        node(i, l, d) {
          var D;
          return i != null && (i = g(i)), l || (l = {}), l = g(l), N(l) || ([d, l] = [l, d]), D = new s(this, i, l), d != null && D.text(d), this.children.push(D), D;
        }
        // Creates a text node
        // `value` element text
        text(i) {
          var l;
          return N(i) && this.element(i), l = new m(this, i), this.children.push(l), this;
        }
        // Creates a CDATA node
        // `value` element text without CDATA delimiters
        cdata(i) {
          var l;
          return l = new p(this, i), this.children.push(l), this;
        }
        // Creates a comment node
        // `value` comment text
        comment(i) {
          var l;
          return l = new r(this, i), this.children.push(l), this;
        }
        // Creates a comment node before the current node
        // `value` comment text
        commentBefore(i) {
          var l, d;
          return l = this.parent.children.indexOf(this), d = this.parent.children.splice(l), this.parent.comment(i), Array.prototype.push.apply(this.parent.children, d), this;
        }
        // Creates a comment node after the current node
        // `value` comment text
        commentAfter(i) {
          var l, d;
          return l = this.parent.children.indexOf(this), d = this.parent.children.splice(l + 1), this.parent.comment(i), Array.prototype.push.apply(this.parent.children, d), this;
        }
        // Adds unescaped raw text
        // `value` text
        raw(i) {
          var l;
          return l = new u(this, i), this.children.push(l), this;
        }
        // Adds a dummy node
        dummy() {
          var i;
          return i = new e(this), i;
        }
        // Adds a processing instruction
        // `target` instruction target
        // `value` instruction value
        instruction(i, l) {
          var d, D, h, c, b;
          if (i != null && (i = g(i)), l != null && (l = g(l)), Array.isArray(i))
            for (c = 0, b = i.length; c < b; c++)
              d = i[c], this.instruction(d);
          else if (N(i))
            for (d in i)
              I.call(i, d) && (D = i[d], this.instruction(d, D));
          else
            M(l) && (l = l.apply()), h = new y(this, i, l), this.children.push(h);
          return this;
        }
        // Creates a processing instruction node before the current node
        // `target` instruction target
        // `value` instruction value
        instructionBefore(i, l) {
          var d, D;
          return d = this.parent.children.indexOf(this), D = this.parent.children.splice(d), this.parent.instruction(i, l), Array.prototype.push.apply(this.parent.children, D), this;
        }
        // Creates a processing instruction node after the current node
        // `target` instruction target
        // `value` instruction value
        instructionAfter(i, l) {
          var d, D;
          return d = this.parent.children.indexOf(this), D = this.parent.children.splice(d + 1), this.parent.instruction(i, l), Array.prototype.push.apply(this.parent.children, D), this;
        }
        // Creates the xml declaration
        // `version` A version number string, e.g. 1.0
        // `encoding` Encoding declaration, e.g. UTF-8
        // `standalone` standalone document declaration: true or false
        declaration(i, l, d) {
          var D, h;
          return D = this.document(), h = new f(D, i, l, d), D.children.length === 0 ? D.children.unshift(h) : D.children[0].type === n.Declaration ? D.children[0] = h : D.children.unshift(h), D.root() || D;
        }
        // Creates the document type declaration
        // `pubID` the public identifier of the external subset
        // `sysID` the system identifier of the external subset
        dtd(i, l) {
          var d, D, h, c, b, O, L, X, S, E;
          for (D = this.document(), h = new t(D, i, l), S = D.children, c = b = 0, L = S.length; b < L; c = ++b)
            if (d = S[c], d.type === n.DocType)
              return D.children[c] = h, h;
          for (E = D.children, c = O = 0, X = E.length; O < X; c = ++O)
            if (d = E[c], d.isRoot)
              return D.children.splice(c, 0, h), h;
          return D.children.push(h), h;
        }
        // Gets the parent node
        up() {
          if (this.isRoot)
            throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
          return this.parent;
        }
        // Gets the root node
        root() {
          var i;
          for (i = this; i; ) {
            if (i.type === n.Document)
              return i.rootObject;
            if (i.isRoot)
              return i;
            i = i.parent;
          }
        }
        // Gets the node representing the XML document
        document() {
          var i;
          for (i = this; i; ) {
            if (i.type === n.Document)
              return i;
            i = i.parent;
          }
        }
        // Ends the document and converts string
        end(i) {
          return this.document().end(i);
        }
        // Gets the previous node
        prev() {
          var i;
          if (i = this.parent.children.indexOf(this), i < 1)
            throw new Error("Already at the first node. " + this.debugInfo());
          return this.parent.children[i - 1];
        }
        // Gets the next node
        next() {
          var i;
          if (i = this.parent.children.indexOf(this), i === -1 || i === this.parent.children.length - 1)
            throw new Error("Already at the last node. " + this.debugInfo());
          return this.parent.children[i + 1];
        }
        // Imports cloned root from another XML document
        // `doc` the XML document to insert nodes from
        importDocument(i) {
          var l, d, D, h, c;
          if (d = i.root().clone(), d.parent = this, d.isRoot = !1, this.children.push(d), this.type === n.Document && (d.isRoot = !0, d.documentObject = this, this.rootObject = d, this.children)) {
            for (c = this.children, D = 0, h = c.length; D < h; D++)
              if (l = c[D], l.type === n.DocType) {
                l.name = d.name;
                break;
              }
          }
          return this;
        }
        // Returns debug string for this node
        debugInfo(i) {
          var l, d;
          return i = i || this.name, i == null && !((l = this.parent) != null && l.name) ? "" : i == null ? "parent: <" + this.parent.name + ">" : (d = this.parent) != null && d.name ? "node: <" + i + ">, parent: <" + this.parent.name + ">" : "node: <" + i + ">";
        }
        // Aliases
        ele(i, l, d) {
          return this.element(i, l, d);
        }
        nod(i, l, d) {
          return this.node(i, l, d);
        }
        txt(i) {
          return this.text(i);
        }
        dat(i) {
          return this.cdata(i);
        }
        com(i) {
          return this.comment(i);
        }
        ins(i, l) {
          return this.instruction(i, l);
        }
        doc() {
          return this.document();
        }
        dec(i, l, d) {
          return this.declaration(i, l, d);
        }
        e(i, l, d) {
          return this.element(i, l, d);
        }
        n(i, l, d) {
          return this.node(i, l, d);
        }
        t(i) {
          return this.text(i);
        }
        d(i) {
          return this.cdata(i);
        }
        c(i) {
          return this.comment(i);
        }
        r(i) {
          return this.raw(i);
        }
        i(i, l) {
          return this.instruction(i, l);
        }
        u() {
          return this.up();
        }
        // can be deprecated in a future release
        importXMLBuilder(i) {
          return this.importDocument(i);
        }
        // Adds or modifies an attribute.
        // `name` attribute name
        // `value` attribute value
        attribute(i, l) {
          throw new Error("attribute() applies to element nodes only.");
        }
        att(i, l) {
          return this.attribute(i, l);
        }
        a(i, l) {
          return this.attribute(i, l);
        }
        // Removes an attribute
        // `name` attribute name
        removeAttribute(i) {
          throw new Error("attribute() applies to element nodes only.");
        }
        // DOM level 1 functions to be implemented later
        replaceChild(i, l) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        removeChild(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        appendChild(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        hasChildNodes() {
          return this.children.length !== 0;
        }
        cloneNode(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        normalize() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM level 2
        isSupported(i, l) {
          return !0;
        }
        hasAttributes() {
          return this.attribs.length !== 0;
        }
        // DOM level 3 functions to be implemented later
        compareDocumentPosition(i) {
          var l, d;
          return l = this, l === i ? 0 : this.document() !== i.document() ? (d = o.Disconnected | o.ImplementationSpecific, Math.random() < 0.5 ? d |= o.Preceding : d |= o.Following, d) : l.isAncestor(i) ? o.Contains | o.Preceding : l.isDescendant(i) ? o.Contains | o.Following : l.isPreceding(i) ? o.Preceding : o.Following;
        }
        isSameNode(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        lookupPrefix(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        isDefaultNamespace(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        lookupNamespaceURI(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        isEqualNode(i) {
          var l, d, D;
          if (i.nodeType !== this.nodeType || i.children.length !== this.children.length)
            return !1;
          for (l = d = 0, D = this.children.length - 1; 0 <= D ? d <= D : d >= D; l = 0 <= D ? ++d : --d)
            if (!this.children[l].isEqualNode(i.children[l]))
              return !1;
          return !0;
        }
        getFeature(i, l) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        setUserData(i, l, d) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getUserData(i) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // Returns true if other is an inclusive descendant of node,
        // and false otherwise.
        contains(i) {
          return i ? i === this || this.isDescendant(i) : !1;
        }
        // An object A is called a descendant of an object B, if either A is 
        // a child of B or A is a child of an object C that is a descendant of B.
        isDescendant(i) {
          var l, d, D, h, c;
          for (c = this.children, D = 0, h = c.length; D < h; D++)
            if (l = c[D], i === l || (d = l.isDescendant(i), d))
              return !0;
          return !1;
        }
        // An object A is called an ancestor of an object B if and only if
        // B is a descendant of A.
        isAncestor(i) {
          return i.isDescendant(this);
        }
        // An object A is preceding an object B if A and B are in the 
        // same tree and A comes before B in tree order.
        isPreceding(i) {
          var l, d;
          return l = this.treePosition(i), d = this.treePosition(this), l === -1 || d === -1 ? !1 : l < d;
        }
        // An object A is folllowing an object B if A and B are in the 
        // same tree and A comes after B in tree order.
        isFollowing(i) {
          var l, d;
          return l = this.treePosition(i), d = this.treePosition(this), l === -1 || d === -1 ? !1 : l > d;
        }
        // Returns the preorder position of the given node in the tree, or -1
        // if the node is not in the tree.
        treePosition(i) {
          var l, d;
          return d = 0, l = !1, this.foreachTreeNode(this.document(), function(D) {
            if (d++, !l && D === i)
              return l = !0;
          }), l ? d : -1;
        }
        // Depth-first preorder traversal through the XML tree
        foreachTreeNode(i, l) {
          var d, D, h, c, b;
          for (i || (i = this.document()), c = i.children, D = 0, h = c.length; D < h; D++) {
            if (d = c[D], b = l(d))
              return b;
            if (b = this.foreachTreeNode(d, l), b)
              return b;
          }
        }
      }
      return Object.defineProperty(w.prototype, "nodeName", {
        get: function() {
          return this.name;
        }
      }), Object.defineProperty(w.prototype, "nodeType", {
        get: function() {
          return this.type;
        }
      }), Object.defineProperty(w.prototype, "nodeValue", {
        get: function() {
          return this.value;
        }
      }), Object.defineProperty(w.prototype, "parentNode", {
        get: function() {
          return this.parent;
        }
      }), Object.defineProperty(w.prototype, "childNodes", {
        get: function() {
          return (!this.childNodeList || !this.childNodeList.nodes) && (this.childNodeList = new a(this.children)), this.childNodeList;
        }
      }), Object.defineProperty(w.prototype, "firstChild", {
        get: function() {
          return this.children[0] || null;
        }
      }), Object.defineProperty(w.prototype, "lastChild", {
        get: function() {
          return this.children[this.children.length - 1] || null;
        }
      }), Object.defineProperty(w.prototype, "previousSibling", {
        get: function() {
          var T;
          return T = this.parent.children.indexOf(this), this.parent.children[T - 1] || null;
        }
      }), Object.defineProperty(w.prototype, "nextSibling", {
        get: function() {
          var T;
          return T = this.parent.children.indexOf(this), this.parent.children[T + 1] || null;
        }
      }), Object.defineProperty(w.prototype, "ownerDocument", {
        get: function() {
          return this.document() || null;
        }
      }), Object.defineProperty(w.prototype, "textContent", {
        get: function() {
          var T, i, l, d, D;
          if (this.nodeType === n.Element || this.nodeType === n.DocumentFragment) {
            for (D = "", d = this.children, i = 0, l = d.length; i < l; i++)
              T = d[i], T.textContent && (D += T.textContent);
            return D;
          } else
            return null;
        },
        set: function(T) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }), w;
    }).call(this);
  }).call(v)), z.exports;
}
var pt = { exports: {} }, oe;
function ge() {
  return oe || (oe = 1, (function() {
    var o = {}.hasOwnProperty;
    pt.exports = (function() {
      class n {
        // Initializes a new instance of `XMLStringifier`
        // `options.version` The version number string of the XML spec to validate against, e.g. 1.0
        // `options.noDoubleEncoding` whether existing html entities are encoded: true or false
        // `options.stringify` a set of functions to use for converting values to strings
        // `options.noValidation` whether values will be validated and escaped or returned as is
        // `options.invalidCharReplacement` a character to replace invalid characters and disable character validation
        constructor(r) {
          var f, t, e;
          this.assertLegalChar = this.assertLegalChar.bind(this), this.assertLegalName = this.assertLegalName.bind(this), r || (r = {}), this.options = r, this.options.version || (this.options.version = "1.0"), t = r.stringify || {};
          for (f in t)
            o.call(t, f) && (e = t[f], this[f] = e);
        }
        // Defaults
        name(r) {
          return this.options.noValidation ? r : this.assertLegalName("" + r || "");
        }
        text(r) {
          return this.options.noValidation ? r : this.assertLegalChar(this.textEscape("" + r || ""));
        }
        cdata(r) {
          return this.options.noValidation ? r : (r = "" + r || "", r = r.replace("]]>", "]]]]><![CDATA[>"), this.assertLegalChar(r));
        }
        comment(r) {
          if (this.options.noValidation)
            return r;
          if (r = "" + r || "", r.match(/--/))
            throw new Error("Comment text cannot contain double-hypen: " + r);
          return this.assertLegalChar(r);
        }
        raw(r) {
          return this.options.noValidation ? r : "" + r || "";
        }
        attValue(r) {
          return this.options.noValidation ? r : this.assertLegalChar(this.attEscape(r = "" + r || ""));
        }
        insTarget(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        insValue(r) {
          if (this.options.noValidation)
            return r;
          if (r = "" + r || "", r.match(/\?>/))
            throw new Error("Invalid processing instruction value: " + r);
          return this.assertLegalChar(r);
        }
        xmlVersion(r) {
          if (this.options.noValidation)
            return r;
          if (r = "" + r || "", !r.match(/1\.[0-9]+/))
            throw new Error("Invalid version number: " + r);
          return r;
        }
        xmlEncoding(r) {
          if (this.options.noValidation)
            return r;
          if (r = "" + r || "", !r.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/))
            throw new Error("Invalid encoding: " + r);
          return this.assertLegalChar(r);
        }
        xmlStandalone(r) {
          return this.options.noValidation ? r : r ? "yes" : "no";
        }
        dtdPubID(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdSysID(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdElementValue(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdAttType(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdAttDefault(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdEntityValue(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        dtdNData(r) {
          return this.options.noValidation ? r : this.assertLegalChar("" + r || "");
        }
        assertLegalChar(r) {
          var f, t;
          if (this.options.noValidation)
            return r;
          if (this.options.version === "1.0") {
            if (f = /[\0-\x08\x0B\f\x0E-\x1F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g, this.options.invalidCharReplacement !== void 0)
              r = r.replace(f, this.options.invalidCharReplacement);
            else if (t = r.match(f))
              throw new Error(`Invalid character in string: ${r} at index ${t.index}`);
          } else if (this.options.version === "1.1") {
            if (f = /[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g, this.options.invalidCharReplacement !== void 0)
              r = r.replace(f, this.options.invalidCharReplacement);
            else if (t = r.match(f))
              throw new Error(`Invalid character in string: ${r} at index ${t.index}`);
          }
          return r;
        }
        assertLegalName(r) {
          var f;
          if (this.options.noValidation)
            return r;
          if (r = this.assertLegalChar(r), f = /^([:A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])([\x2D\.0-:A-Z_a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*$/, !r.match(f))
            throw new Error(`Invalid character in name: ${r}`);
          return r;
        }
        // Escapes special characters in text
        // See http://www.w3.org/TR/2000/WD-xml-c14n-20000119.html#charescaping
        // `str` the string to escape
        textEscape(r) {
          var f;
          return this.options.noValidation ? r : (f = this.options.noDoubleEncoding ? /(?!&(lt|gt|amp|apos|quot);)&/g : /&/g, r.replace(f, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;"));
        }
        // Escapes special characters in attribute values
        // See http://www.w3.org/TR/2000/WD-xml-c14n-20000119.html#charescaping
        // `str` the string to escape
        attEscape(r) {
          var f;
          return this.options.noValidation ? r : (f = this.options.noDoubleEncoding ? /(?!&(lt|gt|amp|apos|quot);)&/g : /&/g, r.replace(f, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;"));
        }
      }
      return n.prototype.convertAttKey = "@", n.prototype.convertPIKey = "?", n.prototype.convertTextKey = "#text", n.prototype.convertCDataKey = "#cdata", n.prototype.convertCommentKey = "#comment", n.prototype.convertRawKey = "#raw", n;
    }).call(this);
  }).call(v)), pt.exports;
}
var mt = { exports: {} }, yt = { exports: {} }, gt = { exports: {} }, ae;
function k() {
  return ae || (ae = 1, (function() {
    gt.exports = {
      None: 0,
      OpenTag: 1,
      InsideTag: 2,
      CloseTag: 3
    };
  }).call(v)), gt.exports;
}
var he;
function we() {
  return he || (he = 1, (function() {
    var o, n, p, r = {}.hasOwnProperty;
    ({ assign: p } = j()), o = P(), Mt(), Et(), Tt(), Ot(), xt(), Ct(), Pt(), Xt(), ye(), Nt(), vt(), Lt(), It(), n = k(), yt.exports = class {
      // Initializes a new instance of `XMLWriterBase`
      // `options.pretty` pretty prints the result
      // `options.indent` indentation string
      // `options.newline` newline sequence
      // `options.offset` a fixed number of indentations to add to every line
      // `options.width` maximum column width
      // `options.allowEmpty` do not self close empty element tags
      // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
      // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
      constructor(t) {
        var e, s, a;
        t || (t = {}), this.options = t, s = t.writer || {};
        for (e in s)
          r.call(s, e) && (a = s[e], this["_" + e] = this[e], this[e] = a);
      }
      // Filters writer options and provides defaults
      // `options` writer options
      filterOptions(t) {
        var e, s, a, y, u, m, g, x, M;
        return t || (t = {}), t = p({}, this.options, t), e = {
          writer: this
        }, e.pretty = t.pretty || !1, e.allowEmpty = t.allowEmpty || !1, e.indent = (s = t.indent) != null ? s : "  ", e.newline = (a = t.newline) != null ? a : `
`, e.offset = (y = t.offset) != null ? y : 0, e.width = (u = t.width) != null ? u : 0, e.dontPrettyTextNodes = (m = (g = t.dontPrettyTextNodes) != null ? g : t.dontprettytextnodes) != null ? m : 0, e.spaceBeforeSlash = (x = (M = t.spaceBeforeSlash) != null ? M : t.spacebeforeslash) != null ? x : "", e.spaceBeforeSlash === !0 && (e.spaceBeforeSlash = " "), e.suppressPrettyCount = 0, e.user = {}, e.state = n.None, e;
      }
      // Returns the indentation string for the current level
      // `node` current node
      // `options` writer options
      // `level` current indentation level
      indent(t, e, s) {
        var a;
        return !e.pretty || e.suppressPrettyCount ? "" : e.pretty && (a = (s || 0) + e.offset + 1, a > 0) ? new Array(a).join(e.indent) : "";
      }
      // Returns the newline string
      // `node` current node
      // `options` writer options
      // `level` current indentation level
      endline(t, e, s) {
        return !e.pretty || e.suppressPrettyCount ? "" : e.newline;
      }
      attribute(t, e, s) {
        var a;
        return this.openAttribute(t, e, s), e.pretty && e.width > 0 ? a = t.name + '="' + t.value + '"' : a = " " + t.name + '="' + t.value + '"', this.closeAttribute(t, e, s), a;
      }
      cdata(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<![CDATA[", e.state = n.InsideTag, a += t.value, e.state = n.CloseTag, a += "]]>" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      comment(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<!-- ", e.state = n.InsideTag, a += t.value, e.state = n.CloseTag, a += " -->" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      declaration(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<?xml", e.state = n.InsideTag, a += ' version="' + t.version + '"', t.encoding != null && (a += ' encoding="' + t.encoding + '"'), t.standalone != null && (a += ' standalone="' + t.standalone + '"'), e.state = n.CloseTag, a += e.spaceBeforeSlash + "?>", a += this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      docType(t, e, s) {
        var a, y, u, m, g;
        if (s || (s = 0), this.openNode(t, e, s), e.state = n.OpenTag, m = this.indent(t, e, s), m += "<!DOCTYPE " + t.root().name, t.pubID && t.sysID ? m += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.sysID && (m += ' SYSTEM "' + t.sysID + '"'), t.children.length > 0) {
          for (m += " [", m += this.endline(t, e, s), e.state = n.InsideTag, g = t.children, y = 0, u = g.length; y < u; y++)
            a = g[y], m += this.writeChildNode(a, e, s + 1);
          e.state = n.CloseTag, m += "]";
        }
        return e.state = n.CloseTag, m += e.spaceBeforeSlash + ">", m += this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), m;
      }
      element(t, e, s) {
        var a, y, u, m, g, x, M, N, I, C, w, T, i, l, d, D, h, c, b;
        if (s || (s = 0), T = !1, this.openNode(t, e, s), e.state = n.OpenTag, i = this.indent(t, e, s) + "<" + t.name, e.pretty && e.width > 0) {
          N = i.length, d = t.attribs;
          for (w in d)
            r.call(d, w) && (a = d[w], l = this.attribute(a, e, s), y = l.length, N + y > e.width ? (b = this.indent(t, e, s + 1) + l, i += this.endline(t, e, s) + b, N = b.length) : (b = " " + l, i += b, N += b.length));
        } else {
          D = t.attribs;
          for (w in D)
            r.call(D, w) && (a = D[w], i += this.attribute(a, e, s));
        }
        if (m = t.children.length, g = m === 0 ? null : t.children[0], m === 0 || t.children.every(function(O) {
          return (O.type === o.Text || O.type === o.Raw || O.type === o.CData) && O.value === "";
        }))
          e.allowEmpty ? (i += ">", e.state = n.CloseTag, i += "</" + t.name + ">" + this.endline(t, e, s)) : (e.state = n.CloseTag, i += e.spaceBeforeSlash + "/>" + this.endline(t, e, s));
        else if (e.pretty && m === 1 && (g.type === o.Text || g.type === o.Raw || g.type === o.CData) && g.value != null)
          i += ">", e.state = n.InsideTag, e.suppressPrettyCount++, T = !0, i += this.writeChildNode(g, e, s + 1), e.suppressPrettyCount--, T = !1, e.state = n.CloseTag, i += "</" + t.name + ">" + this.endline(t, e, s);
        else {
          if (e.dontPrettyTextNodes) {
            for (h = t.children, x = 0, I = h.length; x < I; x++)
              if (u = h[x], (u.type === o.Text || u.type === o.Raw || u.type === o.CData) && u.value != null) {
                e.suppressPrettyCount++, T = !0;
                break;
              }
          }
          for (i += ">" + this.endline(t, e, s), e.state = n.InsideTag, c = t.children, M = 0, C = c.length; M < C; M++)
            u = c[M], i += this.writeChildNode(u, e, s + 1);
          e.state = n.CloseTag, i += this.indent(t, e, s) + "</" + t.name + ">", T && e.suppressPrettyCount--, i += this.endline(t, e, s), e.state = n.None;
        }
        return this.closeNode(t, e, s), i;
      }
      writeChildNode(t, e, s) {
        switch (t.type) {
          case o.CData:
            return this.cdata(t, e, s);
          case o.Comment:
            return this.comment(t, e, s);
          case o.Element:
            return this.element(t, e, s);
          case o.Raw:
            return this.raw(t, e, s);
          case o.Text:
            return this.text(t, e, s);
          case o.ProcessingInstruction:
            return this.processingInstruction(t, e, s);
          case o.Dummy:
            return "";
          case o.Declaration:
            return this.declaration(t, e, s);
          case o.DocType:
            return this.docType(t, e, s);
          case o.AttributeDeclaration:
            return this.dtdAttList(t, e, s);
          case o.ElementDeclaration:
            return this.dtdElement(t, e, s);
          case o.EntityDeclaration:
            return this.dtdEntity(t, e, s);
          case o.NotationDeclaration:
            return this.dtdNotation(t, e, s);
          default:
            throw new Error("Unknown XML node type: " + t.constructor.name);
        }
      }
      processingInstruction(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<?", e.state = n.InsideTag, a += t.target, t.value && (a += " " + t.value), e.state = n.CloseTag, a += e.spaceBeforeSlash + "?>", a += this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      raw(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s), e.state = n.InsideTag, a += t.value, e.state = n.CloseTag, a += this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      text(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s), e.state = n.InsideTag, a += t.value, e.state = n.CloseTag, a += this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      dtdAttList(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<!ATTLIST", e.state = n.InsideTag, a += " " + t.elementName + " " + t.attributeName + " " + t.attributeType, t.defaultValueType !== "#DEFAULT" && (a += " " + t.defaultValueType), t.defaultValue && (a += ' "' + t.defaultValue + '"'), e.state = n.CloseTag, a += e.spaceBeforeSlash + ">" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      dtdElement(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<!ELEMENT", e.state = n.InsideTag, a += " " + t.name + " " + t.value, e.state = n.CloseTag, a += e.spaceBeforeSlash + ">" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      dtdEntity(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<!ENTITY", e.state = n.InsideTag, t.pe && (a += " %"), a += " " + t.name, t.value ? a += ' "' + t.value + '"' : (t.pubID && t.sysID ? a += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.sysID && (a += ' SYSTEM "' + t.sysID + '"'), t.nData && (a += " NDATA " + t.nData)), e.state = n.CloseTag, a += e.spaceBeforeSlash + ">" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      dtdNotation(t, e, s) {
        var a;
        return this.openNode(t, e, s), e.state = n.OpenTag, a = this.indent(t, e, s) + "<!NOTATION", e.state = n.InsideTag, a += " " + t.name, t.pubID && t.sysID ? a += ' PUBLIC "' + t.pubID + '" "' + t.sysID + '"' : t.pubID ? a += ' PUBLIC "' + t.pubID + '"' : t.sysID && (a += ' SYSTEM "' + t.sysID + '"'), e.state = n.CloseTag, a += e.spaceBeforeSlash + ">" + this.endline(t, e, s), e.state = n.None, this.closeNode(t, e, s), a;
      }
      openNode(t, e, s) {
      }
      closeNode(t, e, s) {
      }
      openAttribute(t, e, s) {
      }
      closeAttribute(t, e, s) {
      }
    };
  }).call(v)), yt.exports;
}
var ue;
function St() {
  return ue || (ue = 1, (function() {
    var o;
    o = we(), mt.exports = class extends o {
      // Initializes a new instance of `XMLStringWriter`
      // `options.pretty` pretty prints the result
      // `options.indent` indentation string
      // `options.newline` newline sequence
      // `options.offset` a fixed number of indentations to add to every line
      // `options.allowEmpty` do not self close empty element tags
      // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
      // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
      constructor(p) {
        super(p);
      }
      document(p, r) {
        var f, t, e, s, a;
        for (r = this.filterOptions(r), s = "", a = p.children, t = 0, e = a.length; t < e; t++)
          f = a[t], s += this.writeChildNode(f, r, 0);
        return r.pretty && s.slice(-r.newline.length) === r.newline && (s = s.slice(0, -r.newline.length)), s;
      }
    };
  }).call(v)), mt.exports;
}
var le;
function De() {
  return le || (le = 1, (function() {
    var o, n, p, r, f, t, e;
    ({ isPlainObject: e } = j()), p = pe(), n = Se(), r = R(), o = P(), t = ge(), f = St(), W.exports = (function() {
      class s extends r {
        // Initializes a new instance of `XMLDocument`
        // `options.keepNullNodes` whether nodes with null values will be kept
        //     or ignored: true or false
        // `options.keepNullAttributes` whether attributes with null values will be
        //     kept or ignored: true or false
        // `options.ignoreDecorators` whether decorator strings will be ignored when
        //     converting JS objects: true or false
        // `options.separateArrayItems` whether array items are created as separate
        //     nodes when passed as an object value: true or false
        // `options.noDoubleEncoding` whether existing html entities are encoded:
        //     true or false
        // `options.stringify` a set of functions to use for converting values to
        //     strings
        // `options.writer` the default XML writer to use for converting nodes to
        //     string. If the default writer is not set, the built-in XMLStringWriter
        //     will be used instead.
        constructor(y) {
          super(null), this.name = "#document", this.type = o.Document, this.documentURI = null, this.domConfig = new n(), y || (y = {}), y.writer || (y.writer = new f()), this.options = y, this.stringify = new t(y);
        }
        // Ends the document and passes it to the given XML writer
        // `writer` is either an XML writer or a plain object to pass to the
        // constructor of the default XML writer. The default writer is assigned when
        // creating the XML document. Following flags are recognized by the
        // built-in XMLStringWriter:
        //   `writer.pretty` pretty prints the result
        //   `writer.indent` indentation for pretty print
        //   `writer.offset` how many indentations to add to every line for pretty print
        //   `writer.newline` newline sequence for pretty print
        end(y) {
          var u;
          return u = {}, y ? e(y) && (u = y, y = this.options.writer) : y = this.options.writer, y.document(this, y.filterOptions(u));
        }
        // Converts the XML document to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(y) {
          return this.options.writer.document(this, this.options.writer.filterOptions(y));
        }
        // DOM level 1 functions to be implemented later
        createElement(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createDocumentFragment() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createTextNode(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createComment(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createCDATASection(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createProcessingInstruction(y, u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createAttribute(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createEntityReference(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByTagName(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM level 2 functions to be implemented later
        importNode(y, u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createElementNS(y, u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createAttributeNS(y, u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementsByTagNameNS(y, u) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        getElementById(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM level 3 functions to be implemented later
        adoptNode(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        normalizeDocument() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        renameNode(y, u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        // DOM level 4 functions to be implemented later
        getElementsByClassName(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createEvent(y) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createRange() {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createNodeIterator(y, u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
        createTreeWalker(y, u, m) {
          throw new Error("This DOM method is not implemented." + this.debugInfo());
        }
      }
      return Object.defineProperty(s.prototype, "implementation", {
        value: new p()
      }), Object.defineProperty(s.prototype, "doctype", {
        get: function() {
          var a, y, u, m;
          for (m = this.children, y = 0, u = m.length; y < u; y++)
            if (a = m[y], a.type === o.DocType)
              return a;
          return null;
        }
      }), Object.defineProperty(s.prototype, "documentElement", {
        get: function() {
          return this.rootObject || null;
        }
      }), Object.defineProperty(s.prototype, "inputEncoding", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(s.prototype, "strictErrorChecking", {
        get: function() {
          return !1;
        }
      }), Object.defineProperty(s.prototype, "xmlEncoding", {
        get: function() {
          return this.children.length !== 0 && this.children[0].type === o.Declaration ? this.children[0].encoding : null;
        }
      }), Object.defineProperty(s.prototype, "xmlStandalone", {
        get: function() {
          return this.children.length !== 0 && this.children[0].type === o.Declaration ? this.children[0].standalone === "yes" : !1;
        }
      }), Object.defineProperty(s.prototype, "xmlVersion", {
        get: function() {
          return this.children.length !== 0 && this.children[0].type === o.Declaration ? this.children[0].version : "1.0";
        }
      }), Object.defineProperty(s.prototype, "URL", {
        get: function() {
          return this.documentURI;
        }
      }), Object.defineProperty(s.prototype, "origin", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(s.prototype, "compatMode", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(s.prototype, "characterSet", {
        get: function() {
          return null;
        }
      }), Object.defineProperty(s.prototype, "contentType", {
        get: function() {
          return null;
        }
      }), s;
    }).call(this);
  }).call(v)), W.exports;
}
var wt = { exports: {} }, ce;
function je() {
  return ce || (ce = 1, (function() {
    var o, n, p, r, f, t, e, s, a, y, u, m, g, x, M, N, I, C, w, T, i, l, d = {}.hasOwnProperty;
    ({ isObject: i, isFunction: T, isPlainObject: l, getValue: w } = j()), o = P(), m = De(), g = xt(), r = Tt(), f = Ot(), M = Ct(), C = Pt(), x = Xt(), y = Mt(), u = Et(), t = Nt(), s = Lt(), e = vt(), a = It(), p = me(), I = ge(), N = St(), n = k(), wt.exports = class {
      // Initializes a new instance of `XMLDocumentCB`
      // `options.keepNullNodes` whether nodes with null values will be kept
      //     or ignored: true or false
      // `options.keepNullAttributes` whether attributes with null values will be
      //     kept or ignored: true or false
      // `options.ignoreDecorators` whether decorator strings will be ignored when
      //     converting JS objects: true or false
      // `options.separateArrayItems` whether array items are created as separate
      //     nodes when passed as an object value: true or false
      // `options.noDoubleEncoding` whether existing html entities are encoded:
      //     true or false
      // `options.stringify` a set of functions to use for converting values to
      //     strings
      // `options.writer` the default XML writer to use for converting nodes to
      //     string. If the default writer is not set, the built-in XMLStringWriter
      //     will be used instead.
      // `onData` the function to be called when a new chunk of XML is output. The
      //          string containing the XML chunk is passed to `onData` as its first
      //          argument, and the current indentation level as its second argument.
      // `onEnd`  the function to be called when the XML document is completed with
      //          `end`. `onEnd` does not receive any arguments.
      constructor(h, c, b) {
        var O;
        this.name = "?xml", this.type = o.Document, h || (h = {}), O = {}, h.writer ? l(h.writer) && (O = h.writer, h.writer = new N()) : h.writer = new N(), this.options = h, this.writer = h.writer, this.writerOptions = this.writer.filterOptions(O), this.stringify = new I(h), this.onDataCallback = c || function() {
        }, this.onEndCallback = b || function() {
        }, this.currentNode = null, this.currentLevel = -1, this.openTags = {}, this.documentStarted = !1, this.documentCompleted = !1, this.root = null;
      }
      // Creates a child element node from the given XMLNode
      // `node` the child node
      createChildNode(h) {
        var c, b, O, L, X, S, E, q;
        switch (h.type) {
          case o.CData:
            this.cdata(h.value);
            break;
          case o.Comment:
            this.comment(h.value);
            break;
          case o.Element:
            O = {}, E = h.attribs;
            for (b in E)
              d.call(E, b) && (c = E[b], O[b] = c.value);
            this.node(h.name, O);
            break;
          case o.Dummy:
            this.dummy();
            break;
          case o.Raw:
            this.raw(h.value);
            break;
          case o.Text:
            this.text(h.value);
            break;
          case o.ProcessingInstruction:
            this.instruction(h.target, h.value);
            break;
          default:
            throw new Error("This XML node type is not supported in a JS object: " + h.constructor.name);
        }
        for (q = h.children, X = 0, S = q.length; X < S; X++)
          L = q[X], this.createChildNode(L), L.type === o.Element && this.up();
        return this;
      }
      // Creates a dummy node
      dummy() {
        return this;
      }
      // Creates a node
      // `name` name of the node
      // `attributes` an object containing name/value pairs of attributes
      // `text` element text
      node(h, c, b) {
        if (h == null)
          throw new Error("Missing node name.");
        if (this.root && this.currentLevel === -1)
          throw new Error("Document can only have one root node. " + this.debugInfo(h));
        return this.openCurrent(), h = w(h), c == null && (c = {}), c = w(c), i(c) || ([b, c] = [c, b]), this.currentNode = new g(this, h, c), this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, b != null && this.text(b), this;
      }
      // Creates a child element node or an element type declaration when called
      // inside the DTD
      // `name` name of the node
      // `attributes` an object containing name/value pairs of attributes
      // `text` element text
      element(h, c, b) {
        var O, L, X, S, E, q;
        if (this.currentNode && this.currentNode.type === o.DocType)
          this.dtdElement(...arguments);
        else if (Array.isArray(h) || i(h) || T(h))
          for (S = this.options.noValidation, this.options.noValidation = !0, q = new m(this.options).element("TEMP_ROOT"), q.element(h), this.options.noValidation = S, E = q.children, L = 0, X = E.length; L < X; L++)
            O = E[L], this.createChildNode(O), O.type === o.Element && this.up();
        else
          this.node(h, c, b);
        return this;
      }
      // Adds or modifies an attribute
      // `name` attribute name
      // `value` attribute value
      attribute(h, c) {
        var b, O;
        if (!this.currentNode || this.currentNode.children)
          throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(h));
        if (h != null && (h = w(h)), i(h))
          for (b in h)
            d.call(h, b) && (O = h[b], this.attribute(b, O));
        else
          T(c) && (c = c.apply()), this.options.keepNullAttributes && c == null ? this.currentNode.attribs[h] = new p(this, h, "") : c != null && (this.currentNode.attribs[h] = new p(this, h, c));
        return this;
      }
      // Creates a text node
      // `value` element text
      text(h) {
        var c;
        return this.openCurrent(), c = new C(this, h), this.onData(this.writer.text(c, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates a CDATA node
      // `value` element text without CDATA delimiters
      cdata(h) {
        var c;
        return this.openCurrent(), c = new r(this, h), this.onData(this.writer.cdata(c, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates a comment node
      // `value` comment text
      comment(h) {
        var c;
        return this.openCurrent(), c = new f(this, h), this.onData(this.writer.comment(c, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Adds unescaped raw text
      // `value` text
      raw(h) {
        var c;
        return this.openCurrent(), c = new M(this, h), this.onData(this.writer.raw(c, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Adds a processing instruction
      // `target` instruction target
      // `value` instruction value
      instruction(h, c) {
        var b, O, L, X, S;
        if (this.openCurrent(), h != null && (h = w(h)), c != null && (c = w(c)), Array.isArray(h))
          for (b = 0, X = h.length; b < X; b++)
            O = h[b], this.instruction(O);
        else if (i(h))
          for (O in h)
            d.call(h, O) && (L = h[O], this.instruction(O, L));
        else
          T(c) && (c = c.apply()), S = new x(this, h, c), this.onData(this.writer.processingInstruction(S, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
        return this;
      }
      // Creates the xml declaration
      // `version` A version number string, e.g. 1.0
      // `encoding` Encoding declaration, e.g. UTF-8
      // `standalone` standalone document declaration: true or false
      declaration(h, c, b) {
        var O;
        if (this.openCurrent(), this.documentStarted)
          throw new Error("declaration() must be the first node.");
        return O = new y(this, h, c, b), this.onData(this.writer.declaration(O, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates the document type declaration
      // `root`  the name of the root node
      // `pubID` the public identifier of the external subset
      // `sysID` the system identifier of the external subset
      doctype(h, c, b) {
        if (this.openCurrent(), h == null)
          throw new Error("Missing root node name.");
        if (this.root)
          throw new Error("dtd() must come before the root node.");
        return this.currentNode = new u(this, c, b), this.currentNode.rootNodeName = h, this.currentNode.children = !1, this.currentLevel++, this.openTags[this.currentLevel] = this.currentNode, this;
      }
      // Creates an element type declaration
      // `name` element name
      // `value` element content (defaults to #PCDATA)
      dtdElement(h, c) {
        var b;
        return this.openCurrent(), b = new e(this, h, c), this.onData(this.writer.dtdElement(b, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates an attribute declaration
      // `elementName` the name of the element containing this attribute
      // `attributeName` attribute name
      // `attributeType` type of the attribute (defaults to CDATA)
      // `defaultValueType` default value type (either #REQUIRED, #IMPLIED, #FIXED or
      //                    #DEFAULT) (defaults to #IMPLIED)
      // `defaultValue` default value of the attribute
      //                (only used for #FIXED or #DEFAULT)
      attList(h, c, b, O, L) {
        var X;
        return this.openCurrent(), X = new t(this, h, c, b, O, L), this.onData(this.writer.dtdAttList(X, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates a general entity declaration
      // `name` the name of the entity
      // `value` internal entity value or an object with external entity details
      // `value.pubID` public identifier
      // `value.sysID` system identifier
      // `value.nData` notation declaration
      entity(h, c) {
        var b;
        return this.openCurrent(), b = new s(this, !1, h, c), this.onData(this.writer.dtdEntity(b, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates a parameter entity declaration
      // `name` the name of the entity
      // `value` internal entity value or an object with external entity details
      // `value.pubID` public identifier
      // `value.sysID` system identifier
      pEntity(h, c) {
        var b;
        return this.openCurrent(), b = new s(this, !0, h, c), this.onData(this.writer.dtdEntity(b, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Creates a NOTATION declaration
      // `name` the name of the notation
      // `value` an object with external entity details
      // `value.pubID` public identifier
      // `value.sysID` system identifier
      notation(h, c) {
        var b;
        return this.openCurrent(), b = new a(this, h, c), this.onData(this.writer.dtdNotation(b, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1), this;
      }
      // Gets the parent node
      up() {
        if (this.currentLevel < 0)
          throw new Error("The document node has no parent.");
        return this.currentNode ? (this.currentNode.children ? this.closeNode(this.currentNode) : this.openNode(this.currentNode), this.currentNode = null) : this.closeNode(this.openTags[this.currentLevel]), delete this.openTags[this.currentLevel], this.currentLevel--, this;
      }
      // Ends the document
      end() {
        for (; this.currentLevel >= 0; )
          this.up();
        return this.onEnd();
      }
      // Opens the current parent node
      openCurrent() {
        if (this.currentNode)
          return this.currentNode.children = !0, this.openNode(this.currentNode);
      }
      // Writes the opening tag of the current node or the entire node if it has
      // no child nodes
      openNode(h) {
        var c, b, O, L;
        if (!h.isOpen) {
          if (!this.root && this.currentLevel === 0 && h.type === o.Element && (this.root = h), b = "", h.type === o.Element) {
            this.writerOptions.state = n.OpenTag, b = this.writer.indent(h, this.writerOptions, this.currentLevel) + "<" + h.name, L = h.attribs;
            for (O in L)
              d.call(L, O) && (c = L[O], b += this.writer.attribute(c, this.writerOptions, this.currentLevel));
            b += (h.children ? ">" : "/>") + this.writer.endline(h, this.writerOptions, this.currentLevel), this.writerOptions.state = n.InsideTag;
          } else
            this.writerOptions.state = n.OpenTag, b = this.writer.indent(h, this.writerOptions, this.currentLevel) + "<!DOCTYPE " + h.rootNodeName, h.pubID && h.sysID ? b += ' PUBLIC "' + h.pubID + '" "' + h.sysID + '"' : h.sysID && (b += ' SYSTEM "' + h.sysID + '"'), h.children ? (b += " [", this.writerOptions.state = n.InsideTag) : (this.writerOptions.state = n.CloseTag, b += ">"), b += this.writer.endline(h, this.writerOptions, this.currentLevel);
          return this.onData(b, this.currentLevel), h.isOpen = !0;
        }
      }
      // Writes the closing tag of the current node
      closeNode(h) {
        var c;
        if (!h.isClosed)
          return c = "", this.writerOptions.state = n.CloseTag, h.type === o.Element ? c = this.writer.indent(h, this.writerOptions, this.currentLevel) + "</" + h.name + ">" + this.writer.endline(h, this.writerOptions, this.currentLevel) : c = this.writer.indent(h, this.writerOptions, this.currentLevel) + "]>" + this.writer.endline(h, this.writerOptions, this.currentLevel), this.writerOptions.state = n.None, this.onData(c, this.currentLevel), h.isClosed = !0;
      }
      // Called when a new chunk of XML is output
      // `chunk` a string containing the XML chunk
      // `level` current indentation level
      onData(h, c) {
        return this.documentStarted = !0, this.onDataCallback(h, c + 1);
      }
      // Called when the XML document is completed
      onEnd() {
        return this.documentCompleted = !0, this.onEndCallback();
      }
      // Returns debug string
      debugInfo(h) {
        return h == null ? "" : "node: <" + h + ">";
      }
      // Node aliases
      ele() {
        return this.element(...arguments);
      }
      nod(h, c, b) {
        return this.node(h, c, b);
      }
      txt(h) {
        return this.text(h);
      }
      dat(h) {
        return this.cdata(h);
      }
      com(h) {
        return this.comment(h);
      }
      ins(h, c) {
        return this.instruction(h, c);
      }
      dec(h, c, b) {
        return this.declaration(h, c, b);
      }
      dtd(h, c, b) {
        return this.doctype(h, c, b);
      }
      e(h, c, b) {
        return this.element(h, c, b);
      }
      n(h, c, b) {
        return this.node(h, c, b);
      }
      t(h) {
        return this.text(h);
      }
      d(h) {
        return this.cdata(h);
      }
      c(h) {
        return this.comment(h);
      }
      r(h) {
        return this.raw(h);
      }
      i(h, c) {
        return this.instruction(h, c);
      }
      // Attribute aliases
      att() {
        return this.currentNode && this.currentNode.type === o.DocType ? this.attList(...arguments) : this.attribute(...arguments);
      }
      a() {
        return this.currentNode && this.currentNode.type === o.DocType ? this.attList(...arguments) : this.attribute(...arguments);
      }
      // DTD aliases
      // att() and ele() are defined above
      ent(h, c) {
        return this.entity(h, c);
      }
      pent(h, c) {
        return this.pEntity(h, c);
      }
      not(h, c) {
        return this.notation(h, c);
      }
    };
  }).call(v)), wt.exports;
}
var Dt = { exports: {} }, de;
function Fe() {
  return de || (de = 1, (function() {
    var o, n, p, r = {}.hasOwnProperty;
    o = P(), p = we(), n = k(), Dt.exports = class extends p {
      // Initializes a new instance of `XMLStreamWriter`
      // `stream` output stream
      // `options.pretty` pretty prints the result
      // `options.indent` indentation string
      // `options.newline` newline sequence
      // `options.offset` a fixed number of indentations to add to every line
      // `options.allowEmpty` do not self close empty element tags
      // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
      // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
      constructor(t, e) {
        super(e), this.stream = t;
      }
      endline(t, e, s) {
        return t.isLastRootNode && e.state === n.CloseTag ? "" : super.endline(t, e, s);
      }
      document(t, e) {
        var s, a, y, u, m, g, x, M, N;
        for (x = t.children, a = y = 0, m = x.length; y < m; a = ++y)
          s = x[a], s.isLastRootNode = a === t.children.length - 1;
        for (e = this.filterOptions(e), M = t.children, N = [], u = 0, g = M.length; u < g; u++)
          s = M[u], N.push(this.writeChildNode(s, e, 0));
        return N;
      }
      cdata(t, e, s) {
        return this.stream.write(super.cdata(t, e, s));
      }
      comment(t, e, s) {
        return this.stream.write(super.comment(t, e, s));
      }
      declaration(t, e, s) {
        return this.stream.write(super.declaration(t, e, s));
      }
      docType(t, e, s) {
        var a, y, u, m;
        if (s || (s = 0), this.openNode(t, e, s), e.state = n.OpenTag, this.stream.write(this.indent(t, e, s)), this.stream.write("<!DOCTYPE " + t.root().name), t.pubID && t.sysID ? this.stream.write(' PUBLIC "' + t.pubID + '" "' + t.sysID + '"') : t.sysID && this.stream.write(' SYSTEM "' + t.sysID + '"'), t.children.length > 0) {
          for (this.stream.write(" ["), this.stream.write(this.endline(t, e, s)), e.state = n.InsideTag, m = t.children, y = 0, u = m.length; y < u; y++)
            a = m[y], this.writeChildNode(a, e, s + 1);
          e.state = n.CloseTag, this.stream.write("]");
        }
        return e.state = n.CloseTag, this.stream.write(e.spaceBeforeSlash + ">"), this.stream.write(this.endline(t, e, s)), e.state = n.None, this.closeNode(t, e, s);
      }
      element(t, e, s) {
        var a, y, u, m, g, x, M, N, I, C, w, T, i, l, d;
        if (s || (s = 0), this.openNode(t, e, s), e.state = n.OpenTag, C = this.indent(t, e, s) + "<" + t.name, e.pretty && e.width > 0) {
          M = C.length, T = t.attribs;
          for (I in T)
            r.call(T, I) && (a = T[I], w = this.attribute(a, e, s), y = w.length, M + y > e.width ? (d = this.indent(t, e, s + 1) + w, C += this.endline(t, e, s) + d, M = d.length) : (d = " " + w, C += d, M += d.length));
        } else {
          i = t.attribs;
          for (I in i)
            r.call(i, I) && (a = i[I], C += this.attribute(a, e, s));
        }
        if (this.stream.write(C), m = t.children.length, g = m === 0 ? null : t.children[0], m === 0 || t.children.every(function(D) {
          return (D.type === o.Text || D.type === o.Raw || D.type === o.CData) && D.value === "";
        }))
          e.allowEmpty ? (this.stream.write(">"), e.state = n.CloseTag, this.stream.write("</" + t.name + ">")) : (e.state = n.CloseTag, this.stream.write(e.spaceBeforeSlash + "/>"));
        else if (e.pretty && m === 1 && (g.type === o.Text || g.type === o.Raw || g.type === o.CData) && g.value != null)
          this.stream.write(">"), e.state = n.InsideTag, e.suppressPrettyCount++, this.writeChildNode(g, e, s + 1), e.suppressPrettyCount--, e.state = n.CloseTag, this.stream.write("</" + t.name + ">");
        else {
          for (this.stream.write(">" + this.endline(t, e, s)), e.state = n.InsideTag, l = t.children, x = 0, N = l.length; x < N; x++)
            u = l[x], this.writeChildNode(u, e, s + 1);
          e.state = n.CloseTag, this.stream.write(this.indent(t, e, s) + "</" + t.name + ">");
        }
        return this.stream.write(this.endline(t, e, s)), e.state = n.None, this.closeNode(t, e, s);
      }
      processingInstruction(t, e, s) {
        return this.stream.write(super.processingInstruction(t, e, s));
      }
      raw(t, e, s) {
        return this.stream.write(super.raw(t, e, s));
      }
      text(t, e, s) {
        return this.stream.write(super.text(t, e, s));
      }
      dtdAttList(t, e, s) {
        return this.stream.write(super.dtdAttList(t, e, s));
      }
      dtdElement(t, e, s) {
        return this.stream.write(super.dtdElement(t, e, s));
      }
      dtdEntity(t, e, s) {
        return this.stream.write(super.dtdEntity(t, e, s));
      }
      dtdNotation(t, e, s) {
        return this.stream.write(super.dtdNotation(t, e, s));
      }
    };
  }).call(v)), Dt.exports;
}
var be;
(function() {
  var o, n, p, r;
  ({ assign: p, isFunction: r } = j()), o = pe(), n = De(), je(), St(), Fe(), P(), k(), be = function(f, t, e, s) {
    var a, y;
    if (f == null)
      throw new Error("Root element needs a name.");
    return s = p({}, t, e, s), a = new n(s), y = a.element(f), s.headless || (a.declaration(s), (s.pubID != null || s.sysID != null) && a.dtd(s)), y;
  }, new o();
}).call(v);
const Dr = (o) => {
  var p;
  const n = be("urlset", {
    encoding: "UTF-8"
  }).attribute("xmlns", "http://www.sitemaps.org/schemas/sitemap/0.9").attribute("xmlns:xhtml", "http://www.w3.org/1999/xhtml");
  return o.urls.forEach((r) => {
    const f = new URL(`${o.baseUrl}${r.path}`), t = n.ele("url");
    t.ele("loc", void 0, f.toString()), r.priority && t.ele("priority", r.priority), r.links && r.links.forEach((e) => {
      const s = new URL(
        `${o.baseUrl}${e.pathPrefix ? e.pathPrefix : ""}${r.path}`
      );
      t.ele("xhtml:link", {
        rel: "alternate",
        hreflang: e.hreflang,
        href: s.toString()
      });
    });
  }), n.end((p = o.builder) == null ? void 0 : p.xmlToStringOptions);
};
export {
  We as badRequest,
  nr as createSeoAlternateLinks,
  ir as createSeoCanonical,
  Ce as createSeoMeta,
  Dr as createSitemap,
  tr as deferApiResponseData,
  Be as forbidden,
  Ue as getClientIpAddress,
  Qe as getRequestBaseUrl,
  Ge as getVercelIpCountry,
  Ze as html,
  He as internalServerError,
  xe as isIpAddress,
  Je as methodNotAllowed,
  qe as notFound,
  $e as notModified,
  _e as ok,
  Ye as pdf,
  er as streamToBuffer,
  ke as toManyRequests,
  Ve as unauthorized,
  Ke as unsupportedMediaType,
  rr as useSeo,
  ze as xml
};
